// jshint ignore: start

export default {
  email_suggestion: {
    prefix: 'Did you mean',
    suffix: '?',
    accept_label: 'Change email to {{email}}',
  },
  devise: {
    sessions: {
      signed_in: 'Signed in successfully.',
    },
  },
  auth_modal: {
    aria_label: {
      login: 'Log in to CGTrader',
      signup: 'Sign up to CGTrader',
    },
    header: {
      login_title: 'Welcome back',
      signup_title: 'Create your account',
      login_subtitle: 'Log in to keep creating, designing and downloading.',
    },
    social_divider: 'or with email',
    email_label: 'Email',
    email_placeholder: 'john@email.com',
    email_aria_label: 'Email address',
    opt_in_label: 'Get product updates, community news and offers.',
    submit_button: 'Continue with email',
    switch: {
      already_member: 'Already a member? ',
      log_in: 'Log in',
      new_here: 'New here? ',
      create_account: 'Create an account',
    },
    terms: {
      prefix: 'By continuing I agree to the ',
      terms_link: 'General Terms & Conditions',
      middle: ' and ',
      privacy_link: 'Privacy Policy.',
      suffix: '',
    },
    code: {
      title: 'Check your inbox',
      subtitle_prefix: 'We sent a 6-digit code to ',
      subtitle_suffix: '',
      email_fallback: 'your email',
      digit_aria_label: 'Digit {{number}}',
      error: 'Invalid access code. Please try again.',
      resend_prompt: "Didn't receive it? ",
      resend_link: 'Resend code',
      resend_countdown: 'Resend code in {{time}}',
      change_email_link: 'Change email',
    },
    success: {
      login_title: 'Welcome back',
      signup_title: "You're in",
      signed_in_prefix: 'Signed in as ',
      signed_in_suffix: '',
      signup_subtitle: "Account created. Let's find your next model.",
    },
    password: {
      link: 'Log in with password instead',
      email_label: 'Email or Username',
      title: 'Log in with password',
      subtitle: 'Enter your email and password to continue.',
      password_label: 'Password',
      forgot_password: 'Forgot password?',
      submit_button: 'Log in',
      back: 'Back',
      show_password: 'Show password',
      hide_password: 'Hide password',
      error_generic: 'Something went wrong. Please try again later.',
      required_notice: 'Please also enter your password to complete the 2FA.',
      two_fa_code_label: 'Verification code',
    },
  },
  login: {
    divider: 'or',
    email_label: 'Email or Username',
    email_confirmation_label: 'Email Confirmation',
    password_label: 'Password',
    forgot_password: 'Forgot password?',
    remember_me: 'Remember me',
    submit_button: 'Log in',
    generic_auth_error: 'Something went wrong. Please try again later.',
    validation: {
      email_username_required: 'Email/Username is required',
      password_required: 'Password is required',
    },
    two_fa: {
      title: 'Enter your login verification code',
      description: 'The verification code was sent to the email address you use to log in to your CGTrader account',
      verify_button: 'Verify',
      error_empty: 'Please enter code',
    },
  },
  register: {
    divider: 'or',
    email_label: 'Email',
    email_confirmation_label: 'Email Confirmation',
    password_label: 'Password',
    gdpr_label: 'Get product updates, community news and offers.',
    submit_button: 'Register',
    email_available: 'Email is available',
    email_taken: 'Email is taken by another account',
    terms_prefix: 'By continuing I agree to the',
    terms_link: 'Terms & Conditions',
    terms_middle: 'and',
    privacy_link: 'Privacy Policy.',
    validation: {
      email_required: 'Email is required',
      email_invalid: 'Please enter a valid email address',
      password_required: 'Password is required',
      password_min_length: 'Password must be at least 6 characters',
      password_weak: 'Please enter a stronger password',
      password_too_short: 'Please enter a longer password to continue',
      password_too_weak: 'Please enter a stronger password to continue',
    },
  },
  useCases: {
    area: {
      title: {
        make: '3D MAKES OF THIS MODEL',
        useCase: 'USE CASES OF THIS MODEL',
      },
      tooltip: {
        make: {
          line1: 'Discover real-life 3D prints created by other users using',
          line2: 'this 3D printable model.',
        },
        useCase: {
          line1: 'Browse real-world photos, videos, and renders showcasing how other users',
          line2: 'have used this 3D model',
        },
      },
      add: {
        make: 'Add 3D Make',
        useCase: 'Add Use Case',
      },
      empty: {
        make: 'See how this model looks when 3D printed - upload your prints to share your results and inspire others!',
        useCase: 'Be the first to showcase how this 3D model can be used in real-world projects - upload your images or videos to inspire others!',
      },
    },
    sidebar: {
      unsavedChanges: 'You have unsaved changes. Discard your submission?',
      yes: 'Yes',
      no: 'No',
      deleteConfirm: {
        make: 'Are you sure you want to delete this 3D Make?',
        useCase: 'Are you sure you want to delete this Use Case?',
      },
      delete: 'Delete',
      cancel: 'Cancel',
      share: {
        make: 'Share my make',
        useCase: 'Share the use case',
      },
      tabs: {
        recent: 'Most recent',
        popular: 'Most popular',
      },
      emptyTitle: {
        make: 'No 3D Makes yet',
        useCase: 'No Use Cases yet',
      },
      emptySubtitle: {
        make: 'Share how this model looks when 3D printed! Upload your 3D Make to inspire others.',
        useCase: 'Be the first to showcase how this 3D model can be used in real-world projects. Upload your images or videos to inspire others.',
      },
    },
    permission: {
      alreadyPosted: {
        make: 'You already posted a 3D Make for this model.',
        useCase: 'You already posted a Use Case for this model.',
      },
      downloadRequired: {
        make: 'You need to download this model to add 3D Makes',
        useCase: 'You need to download this model to add a Use Case',
      },
      purchaseRequired: {
        make: 'Purchase this model to share your 3D Make and inspire others.',
        useCase: 'Purchase this model to share your Use Case and inspire others.',
      },
    },
    form: {
      upload: 'Upload up to {{count}} images or videos',
      uploadFiles: 'Upload files',
      processing: 'Processing files... {{percentage}}%',
      processedCount: '{{completed}} of {{total}} files processed',
      linkPlaceholder: 'Paste a website or social media link',
      add: 'Add',
      dragToReorder: 'Drag to reorder',
      dropToReorder: 'Drop here to reorder',
      removeMedia: 'Remove media',
      mediaCount: '{{count}} / {{max}} media files',
      descriptionLabel: {
        make: 'Your comment',
        useCase: 'Description',
      },
      descriptionPlaceholder: {
        make: 'Share your printing experience',
        useCase: 'Describe how you used this model',
      },
      printerLabel: 'Printer used',
      printerEditLabel: '3D Printer',
      printerPlaceholder: 'Select a 3D printer',
      materialLabel: 'Material',
      materialPlaceholder: 'Select material',
      printResultLabel: 'How did your print turn out?',
      printResultPlaceholder: 'Select result',
      technicalDetails: 'Add more technical details',
      technologyLabel: 'Printing technology',
      technologyPlaceholder: 'Select technology',
      printTimeLabel: 'Printing time',
      printTimePlaceholder: 'Select time',
      supportsUsed: 'Supports used?',
      slicerUpload: 'Upload slicer file',
      slicerHint: 'Supports .3mf, .curaprofile, .fff, .gcode, .ini, .stlproj',
      replace: 'Replace',
      delete: 'Delete',
    },
    errors: {
      maxFiles: 'You can only upload a maximum of {{count}} files.',
      invalidLink: 'Invalid link. Paste a website or social media URL, e.g. https://example.com',
      linkTooLong: 'Links can be up to {{count}} characters long.',
      duplicateMedia: {
        make: 'This media file has already been added to the 3D Makes.',
        useCase: 'This media file has already been added to the Use Cases.',
      },
      unsupportedImage: 'Unsupported image format. Please upload your image in JPG, PNG, GIF, WEBP, AVIF, MOV or MP4 format.',
      fileTooLarge: '{{name}} exceeds the maximum file size of 5.5GB',
      unsupportedFileType: '{{name}} is not a supported file type',
      slicerTooLarge: 'File exceeds the maximum size of 1GB',
      slicerUnsupported: 'Unsupported file type. Please upload a valid slicer file.',
      processingFile: 'Error processing file {{name}}: {{error}}',
      printerTypes: 'Failed to load printer types. Please try again later.',
      prepareForm: 'Failed to prepare form data. Please try again.',
      post: {
        make: 'Failed to post 3D Make. Please try again.',
        useCase: 'Failed to post Use Case. Please try again.',
      },
      postInvalid: {
        make: 'Failed to post 3D Make. Please check your input and try again.',
        useCase: 'Failed to post Use Case. Please check your input and try again.',
      },
      alreadyShared: {
        make: "You've already shared a 3D Make for this model. Each buyer can submit only one 3D Make per model to keep things organized",
        useCase: "You've already shared a Use Case for this model. Each buyer can submit only one Use Case per model to keep things organized",
      },
      fieldRequired: '{{field}} is required',
      fieldUser: 'User',
      fieldMediaFile: 'Media file',
      approve: {
        make: 'Failed to approve 3D Make. Please try again.',
        useCase: 'Failed to approve Use Case. Please try again.',
      },
      delete: {
        make: 'Failed to delete 3D Make. Please try again.',
        useCase: 'Failed to delete Use Case. Please try again.',
      },
      reject: {
        make: 'Failed to reject 3D Make. Please try again.',
        useCase: 'Failed to reject Use Case. Please try again.',
      },
      update: {
        make: 'Failed to update 3D Make. Please try again.',
        useCase: 'Failed to update Use Case. Please try again.',
      },
    },
    status: {
      posting: {
        make: 'Posting your 3D Make...',
        useCase: 'Posting your use case...',
      },
      posted: {
        make: '3D Make posted successfully!',
        useCase: 'Use case posted successfully!',
      },
      pendingReview: {
        make: 'You have successfully posted content on CGTrader. It will remain invisible to the public until we verify that everything is in order. After checking this 3D Make will appear publicly.',
        useCase: 'You have successfully posted content on CGTrader. It will remain invisible to the public until we verify that everything is in order. After checking this Use Case will appear publicly.',
      },
      updating: {
        make: 'Updating 3D Make...',
        useCase: 'Updating Use Case...',
      },
      approved: {
        make: '3D Make approved successfully',
        useCase: 'Use case approved successfully',
      },
      deleted: {
        make: '3D Make deleted successfully',
        useCase: 'Use case deleted successfully',
      },
      rejected: {
        make: '3D Make rejected successfully',
        useCase: 'Use case rejected successfully',
      },
      updated: {
        make: '3D Make updated successfully',
        useCase: 'Use case updated successfully',
      },
    },
    viewer: {
      carousel: {
        make: '3D Make media carousel',
        useCase: 'Use case media carousel',
      },
      previous: 'Previous media',
      next: 'Next media',
      goTo: 'Go to media {{index}} of {{total}}',
      like: 'Like',
      unlike: 'Unlike',
      delete: {
        make: 'Delete 3D Make',
        useCase: 'Delete Use Case',
      },
      edit: {
        make: 'Edit 3D Make',
        useCase: 'Edit Use Case',
      },
      save: 'Save',
      saveChanges: 'Save changes',
      cancel: 'Cancel',
      cancelEditing: 'Cancel editing',
      approve: 'Approve',
      reject: 'Reject',
      video: {
        make: '3D Make video',
        useCase: 'Use case video',
      },
      videoEmbed: {
        make: '3D Make video embed',
        useCase: 'Use case video embed',
      },
      image: {
        make: '3D Make',
        useCase: 'Use case',
      },
      xPost: 'X Post',
      processing: 'Processing...',
      openLink: 'Open link',
    },
    info: {
      createdBy: 'Created by',
      added: 'Added',
      printerUsed: 'Printer used',
      material: 'Material',
      printResult: 'How did your print turn out?',
      slicerDetails: 'Slicer details',
      technology: 'Printing technology',
      printTime: 'Print time',
      supportsUsed: 'Supports used?',
      yes: 'Yes',
      noDescription: 'No description provided',
      notSpecified: 'Not specified',
      purchaseToDownloadSlicer: 'Purchase this model to download slicer files',
      processing: 'Processing...',
    },
    options: {
      technology: {
        fdm: 'FDM',
        sla: 'SLA',
        sls: 'SLS',
        poly_jet: 'PolyJet',
        metal_printing: 'Metal 3D Printing',
        metal_jet: 'Multi Jet Fusion',
        other: 'Other',
      },
      material: {
        pla: 'PLA',
        abs: 'ABS',
        petg: 'PETG',
        resin: 'Resin',
        tpu: 'TPU (Flexible)',
        nylon: 'Nylon',
        other: 'Other',
      },
      printResult: {
        success: 'Printed successfully',
        minor_issues: 'Minor issues',
        failed: 'Print failed',
      },
      printTime: {
        under_2h: 'Under 2 hours',
        '2_5h': '2–5 hours',
        '5_10h': '5–10 hours',
        over_10h: 'Over 10 hours',
      },
    },
  },
  itemPage: {
    licenseDropdown: {
      aiContactNote: {
        question: 'Need an AI-friendly license?',
        linkText: 'Contact our sales team for Enterprise data licensing options.',
      },
    },
    headerSection: {
      likeTooltip: 'Like this model to show appreciation to the designer.',
      viewsTooltip: 'See how many times this model was viewed.',
      shareTooltip: 'Share this model to support the designer and boost their visibility.',
    },
    priceBadges: {
      bestPriceGuaranteed: 'Found this model cheaper on another marketplace? Let our support team know - we’ll match it.',
      new: 'Recently added to CGTrader - explore one of the latest models on the marketplace.',
      topSelling: 'One of the best-selling models in its category - trusted by many buyers.',
      cgtStandard: 'This model passed automated CGT Standard checks and meets professional, PBR ready standards.',
      topRated: 'Highly rated by buyers for exceptional quality and reliability.',
      aiGenerated: 'This model was created using AI-assisted tools or workflows.',
      designerPick: 'Personally highlighted by the designer as one of their standout creations.',
      threeDPrintVerified: 'Verified as 3D printable based on user makes, positive feedback, and technical checks.',
    },
    verifiedByCGTrader: {
      fbxTooltipContent: 'This FBX file has successfully passed the CGT Standard technical and visual checks. The verification results are detailed in the section below.',
      stlTooltipContent: 'This STL file was successfully processed through the CGT Standard technical checks. The verification results are detailed in the section below.',
      geometryTooltipContent: 'Revisión de la geometría para asegurar que el modelo sea hermético y esté libre de problemas de superficie o bordes.',
      geometryTooltips: {
        noSelfIntersections: 'The model must not have geometry where surfaces or parts of the mesh cut through each other'
      },
    },
    geometryDetails: {
      volumeUnit: 'mm³',
      volumeTooltipContent: 'Total solid space the model occupies. Used to estimate material usage and print cost.',
      boundingBoxTooltipContent: 'The smallest 3D box that fully contains the model. Helps determine print size and fit on a printer’s build plate.',
      thinWallsTooltipContent: 'Number of model areas thinner than 0.2 mm.',
    },
    units: {
      mm: 'Millimeters',
      cm: 'Centimeters',
      in: 'Inches',
      m: 'Meters',
    },
    supportForm: {
      messageSent: 'Message has been successfully sent',
    },
  },
  listingPage: {
    subscriptionLabel: {
      free: 'Free in subscription',
      yours: 'Yours to download',
      upgrade: 'Upgrade to download',
    },
    pagination: {
      label: 'Pagination',
      firstPage: 'Go to first page',
      previousPage: 'Go to previous page',
      nextPage: 'Go to next page',
      lastPage: 'Go to last page',
      page: 'Page {{number}}',
    },
    filters: {
      allFilters: 'ALL FILTERS',
      resetFilters: 'Reset',
      lastUsed: 'Last used',
      fileFormat: 'File format',
      searchPlaceholder: 'Type in to search',
      price: {
        freeOnly: 'Free only',
        onSale: 'On sale (up to {{percentage}}% off)',
      },
      customPriceRange: 'Custom price range',
      quickSelections: 'Quick selections',
      subscriptionTier: {
        label: 'Subscriptions',
        all: 'All',
        yourPlan: 'Your plan',
      },
      pricePlaceholder: 'Price',
      polyCountRange: 'Custom poly-count range',
      cardSize: 'Card size',
      cardVisibility: 'Visibility settings',
      visibility: {
        format: 'Format',
        price: 'Price',
        cgtStandard: 'CGT Standard',
        type: 'Type',
        title: 'Title',
        quickActionsOnHover: 'Quick actions on hover',
        suggestions: 'Suggestions',
      },
      items: 'items',
      perPage: 'Per page:',
      wishListOnly: 'Show wishlist only',
      hideOwnedModels: 'Hide owned models',
      ownedModels: 'Purchased models only',
      sortBy: {
        default: 'Default',
        label: 'Sort by',
      },
      remaining: {
        label: 'Filters',
      },
      showMoreButtonText: 'Show more',
    },
    suggestedSearch: {
      showingResultsFor: 'Showing results for',
      ifYouMeant: 'If you meant',
      tryThatSearchInstead: 'try that search instead',
    },
    gallery: {
      formats: 'Formats',
      geometry: 'Geometry',
      type: 'Type',
      details: 'Details',
      unknown: 'Unknown',
      polygons: '{{value}} Polygons',
      vertices: '{{value}} Vertices',
      previewing: 'PREVIEWING',
      types: {
        print_ready: '3D Print',
        pbr: 'PBR',
        animated: 'Animated',
        rigged: 'Rigged',
        low_poly: 'Low poly',
      },
      attributes: {
        textures: 'Textures',
        materials: 'Materials',
        uvw_mapping: 'UV Mapping',
        plugins_used: 'Plugins used',
      },
    },
    actions: {
      preview: 'Preview',
      see_similar_models: 'See similar models',
      add_to_cart: 'Add to cart',
      remove_from_cart: 'Remove from cart',
      add_to_wishlist: 'Add to wishlist',
      remove_from_wishlist: 'Remove from wishlist',
      purchased: 'Purchased',
      open: 'Open',
    },
    download: {
      tooltip: 'Download',
      header: 'Download files',
      loading: 'Loading files...',
      empty: 'No files available for download.',
    },
    upsellBlock: {
      label: 'special offer',
      heading: 'Download more models for less',
      body: '25 models/mo from $9.99',
      cta: 'Get Subscription',
    },
    footerBanners: {
      title: 'Can\'t find what you\'re looking for?',
      hire3dFreelancerBanner: {
        title: 'Hire 3D Freelancer',
        description: 'You\'ll have the opportunity to collaborate directly with skilled 3D designers on a wide range of custom projects, including 3D printing and animation.',
        description2: 'Simply submit a project description and receive price quotes from different designers, allowing you to select the most fitting one for your needs.',
        learnMoreButtonText: 'Learn more',
        learnMoreButtonUrl: '/3d-modeling-jobs',
        postAProjectButtonText: 'Post a Project',
      },
      searchSubscription: {
        title: 'Subscribe to Your Search',
        description: 'We\'ll remember the search settings and notify you if something new comes up.',
        subscribe: 'Subscribe',
        subscribing: 'Subscribing...',
        inputPlaceholder: 'Describe your search with more details so it will help us significantly improve the 3D model library.',
      },
    },
  },
  browser: {
    filters: {
      cgt_standard_only: 'CGT Standard',
      cgt_standard_tooltip_title: 'CGT Standard - import-ready, no cleanup needed.',
      cgt_standard_tooltip_body: 'Automatically checked across geometry, UVs, texturing, scene setup, and naming - works in Blender, Maya, Unreal Engine, Unity, and other major tools. Automatically verified - not self-reported by the seller.',
    },
  },
  profile: {
    my_purchases: {
      archive_file: {
        title: 'Choose a file to open',
        description: 'This model\'s files are inside an archive. Choose the 3D model to open in AI Studio.',
        list_label: 'Files in the archive',
        submit: 'Open Selected File',
        cancel: 'Cancel',
      },
      open_error: {
        no_compatible_file: 'This model has no GLB, glTF, FBX, OBJ or STL file that can be used in AI Studio.',
        file_too_large: 'This model\'s files exceed the {{limit}}MB AI Studio limit.',
        generic: 'This model can\'t be opened in AI Studio.',
      },
    },
    model_uploader: {
      file_not_finalized_tooltip: 'This file didn\'t finish uploading and won\'t be published. Remove it and upload again.',
      file_not_finalized_sr: 'File didn\'t finish uploading and won\'t be published.',
    },
    my_models: {
      product_types: {
        placeholder: 'Type',
        model: '3D Model',
        printable: '3D Print Model',
        cad: 'CAD Model',
        scene: 'Scene',
        pack: 'Pack',
      },
      pack_creation: {
        flash_error: 'Something went wrong, please try again',
        load_error: 'We couldn\'t load the selected models. This can happen when too many models are selected at once. Please try again, or select fewer models.',
        retry: 'Try again',
      },
      image_restore: {
        body_default: 'Some model previews may have been affected by a recent storage issue. If any of your images look broken, click Restore images and we\'ll re-check and fix them across all your models.',
        title_pending: 'We\'re restoring your previews',
        body_pending: 'Your request is in — we\'re re-checking every model. This runs in the background and can take up to 3 days, so you don\'t need to keep this page open. We\'ll notify you here and by email when it\'s done.',
        title_finished: 'Restore complete',
        body_finished: 'We re-checked all your models and restored what we could. If a thumbnail still shows \'No preview\', that image couldn\'t be recovered — you can re-upload it.',
        button_restore: 'Restore images',
        button_requested: 'Restore requested',
        helper_within_3_days: 'Previews update within 3 days.',
      },
      errors: {
        load_failed: 'We could not load your models. Please refresh the page and try again.',
      },
    },
    my_sales: {
      refunded_badge: 'Refunded',
      latest_sales: {
        pagination: {
          summary: 'Showing {{start}}-{{end}} of {{total}} sales',
          no_sales: 'No sales yet',
          jump_to_page: 'Jump to page',
          go_to_first_page: 'Go to first page',
          go_to_previous_page: 'Go to previous page',
          go_to_next_page: 'Go to next page',
          go_to_last_page: 'Go to last page',
        },
      },
      leave_program_modal: {
        header: 'Leave Maximize your earnings program',
        primary_action: 'Leave Maximize your earnings program',
        cancel: 'Cancel',
        description: 'Are you sure you want to stop participating in the Maximize your earnings program?',
        bullet_models: 'All your models will no longer participate in Subscription earnings',
        bullet_promotion: 'You will not be included in enterprise, revenue share, equity, or alternative compensation deals',
        bullet_revenue: 'You will continue earning from standard marketplace sales as usual',
        warning_title: 'Important: Monthly Earnings Logic',
        warning_active_deals: 'Participation is snapshotted at 00:00 on the 1st day of each month',
        warning_pending_payouts: 'If you leave during the month, your current month\'s earnings will not be affected',
        warning_re_enroll: 'Changes take effect starting from the next monthly cycle',
        warning_historical_data: 'Revenue pools are calculated monthly based on actual downloads during that month',
        info_line: 'Your earnings for the current month remain secure and will be paid out according to the standard payout schedule.',
      },
      earnings_detail: {
        generate_report: 'Generate report',
        report_sent_confirmation: 'Report will be sent to your email shortly!',
        errors: {
          sales_load_failed: 'Unable to load sales earnings.',
          downloads_load_failed: 'Unable to load download earnings.',
          subscription_earnings_load_failed: 'Unable to load subscription earnings.',
        },
      },
    },
  },
  publisher: {
    scene: {
      label: 'Full scene',
      detected_prompt: 'We detected this model as a full scene. Uncheck it if it is not one.',
    },
    geometry_types: [
      {
        value: '',
        label: 'Choose geometry',
      },
      {
        value: 'polygon_mesh',
        label: 'Polygon mesh',
      },
      {
        value: 'gaussian_splats',
        label: 'Point-based (Gaussian Splats)',
      },
      {
        value: 'subdivision_ready',
        label: 'Subdivision-ready',
      },
      {
        value: 'nurbs',
        label: 'Nurbs',
      },
      {
        value: 'other',
        label: 'Other',
      },
    ],
    unwrapped_uvs: [
      {
        value: 'unknown',
        label: 'Unknown',
      },
      {
        value: 'non_overlapping',
        label: 'Non-overlapping',
      },
      {
        value: 'overlapping',
        label: 'Overlapping',
      },
      {
        value: 'mixed',
        label: 'Mixed',
      },
      {
        value: 'no',
        label: 'No',
      },
    ],
    units: [
      {
        value: 'mm',
        label: 'Millimeters',
      },
      {
        value: 'cm',
        label: 'Centimeters',
      },
      {
        value: 'in',
        label: 'Inches',
      },
      {
        value: 'm',
        label: 'Meters',
      },
    ],
    licenses_free: [
      {
        value: 'royalty_free_no_ai',
        label: 'Royalty free',
      },
      {
        value: 'editorial_no_ai',
        label: 'Editorial',
      },
      {
        value: 'custom_no_ai',
        label: 'Custom',
      },
    ],
    licenses_paid: [
      {
        value: 'royalty_free',
        label: 'Royalty free',
      },
      {
        value: 'editorial',
        label: 'Editorial',
      },
      {
        value: 'custom',
        label: 'Custom',
      },
    ],
    tooltips: {
      tags: 'First 4-6 tags are most important for search. Describe the main object first, then add details.',
      adult_content: 'All models with nudity or violent content will be reviewed prior to publishing by CGTrader within 1–3 business days. CGTrader uses RSAC standards to evaluate content. Level 0 content is available to everyone. Models classified as Level 1-2 can be published under an age lock. Models classified as Level 3-4 are not approved for publishing on the marketplace.',
    },
    payment_agreement_blocker: {
      message: 'Before you can publish your model, you need to complete and verify your Payment Agreement. This ensures you can receive payments for your sales.',
      cta: 'Complete Payment Agreement',
      dismiss: 'Continue editing',
    },
    licenses_paid_no_ai: [
      {
        value: 'royalty_free_no_ai',
        label: 'Royalty free',
      },
      {
        value: 'editorial_no_ai',
        label: 'Editorial',
      },
      {
        value: 'custom_no_ai',
        label: 'Custom',
      },
    ],
  },
  printModelPage: {
    sectionTitle: '3D Printing',
    heroTitle: 'Explore models for 3D printing',
    sectionDescription: 'High-quality 3D print models, files, and assets ready for home or professional use with FDM, SLA, or SLS 3D printers.',
    placeholderText: 'Search over 800,000 3D print models',
    allCategories: 'Browse all models',
    categorySectionTitle: "3D print files for every idea",
    categorySectionDescription: "Browse high-quality 3D print files designed for FDM, SLA, or resin 3D printing. Find the right 3D printed model for any project.",
    categorySectionButtonText: "Browse all files",
    categorySectionBadgeText: "CATEGORIES",
    budgetSectionTitle: "Explore models that will fit your budget",
    budgetSectionDescription: "Discover cost-effective models without compromising quality",
    BrowseAllText: 'Browse All'
  },
  projects: {
    newestFirst: 'Newest first',
    highestBudget: 'Highest budget',
    fewestApplicants: 'Fewest applicants',
    modelingJob: '3d modeling job',
    myProjects: 'My 3D Projects',
    projects: '3D Projects',
    reviewProjectApplication: 'Review 3D Project application',
    startAProject: 'Start a Project',
    editProject: 'Edit Project',
    reviewProject: 'Review Project',
    applyToProject: 'Apply to 3D Project',
    editProjectApplication: 'Edit 3D Project application',
    learnMoreHowItWorks: 'Learn more how it works',
    projectsDashboard: 'Projects dashboard',
    cgtraderModelingJob: 'CGTrader 3D Modeling Jobs',
    software: '3D Software',
    skills: '3D Skills',
    searchPlaceholder: 'Search'
  },
  subscription_management: {
    plan_change: {
      title: 'Switch plan',
      intro: 'Choose the plan you want.',
      current_badge: 'Current',
      current_plan: 'Your current plan: {{plan}}',
      plan_label: '{{tier}} · {{term}}',
      keep_plan: 'Keep {{plan}}',
      tiers: {
        essentials: 'Essentials',
        premium: 'Premium',
      },
      terms: {
        monthly: 'Monthly',
        annual: 'Annual',
      },
      per_term: {
        monthly: '/month',
        annual: '/year',
      },
      price_note_monthly: 'or {{annualPrice}}/year · {{catalog}}+ models',
      price_note_annual: 'paid upfront · {{catalog}}+ models',
      actions: {
        switch_to_annual: 'Switch to annual',
        switch_to_monthly: 'Switch to monthly',
        upgrade: 'Upgrade to {{plan}}',
        upgrade_annual: 'Upgrade to {{plan}} annual',
        downgrade: 'Downgrade to {{plan}}',
        downgrade_annual: 'Downgrade to {{plan}} annual',
      },
      starts_today: 'Starts today · unused allowance credited',
      takes_effect: 'Takes effect {{date}}',
      best_value: "You're on the best value for this plan",
      schedule: {
        title_downgrade_monthly: 'Downgrade to {{plan}} monthly',
        change_line: '{{from}} → {{to}}',
        downgrade_notice: 'Your plan will switch to {{plan}} at your next billing date on {{date}}. You keep all {{currentPlan}} benefits until then.',
        downgrade_notice_annual: 'Your plan will switch to {{plan}} at the end of your paid year on {{date}}. You keep all {{currentPlan}} benefits until then.',
        plan_monthly: '{{plan}} (monthly)',
        downgrade_details: 'From {{date}}: {{plan}} catalog only, {{downloads}} downloads or {{generations}} AI generations a month, {{price}}.',
        licensed: "Models you've downloaded stay licensed.",
        to_monthly_notice: "Your plan will switch to {{monthly}} at the end of your paid year on {{date}}. You keep your annual plan until then — afterwards you're billed {{price}} with no commitment. No action needed until then.",
        back: 'Back',
        confirm_downgrade: 'Downgrade on {{date}}',
        confirm_to_monthly: 'Switch to monthly (takes effect {{date}})',
      },
      done: {
        title: 'Change scheduled',
        downgrade: "You'll move to {{plan}} on {{date}}. Until then you keep {{currentPlan}}. You can undo this anytime from your subscription page.",
        to_monthly: "You'll move to {{monthly}} on {{date}}. Until then you keep your annual rate. You can undo this anytime from your subscription page.",
        monthly_billing: 'monthly billing',
        button: 'Done',
      },
      pending: {
        banner_downgrade: '{{plan}} — Switches to {{target}} on {{date}}',
        banner_to_monthly: '{{plan}} — Switches to monthly billing on {{date}}',
        title_downgrade: 'Switching to {{plan}} on {{date}}',
        title_to_monthly: 'Switching to monthly billing on {{date}}',
        description_downgrade: 'You keep all {{currentPlan}} benefits until then. On that date your plan changes to {{plan}} at {{price}}.',
        plan_with_term: {
          monthly: '{{plan}} monthly plan',
          annual: '{{plan}} annual plan',
        },
        description_to_monthly: 'You keep your annual plan until then. On that date {{plan}} moves to monthly billing at {{price}} with no commitment — cancel anytime.',
        keep_current_plan: 'Keep current plan',
      },
    },
    payment_failed: {
      badge: 'Payment failed',
      title: 'Payment issue — update payment method',
      description: "Your last payment attempt failed. We'll retry automatically, or you can update the payment method to retry now. Plan changes are unavailable until the payment goes through.",
      action: 'Update payment method',
    },
    state_notices: {
      pause_scheduled: {
        title: 'Pausing on {{date}} for 1 month',
        description: 'You keep your allowance until then. The subscription resumes automatically on {{date}}, when billing restarts. Your price stays the same.',
        action: "Don't pause",
      },
      suspended: {
        badge: 'Suspended',
        title: 'Your subscription has been suspended',
        description: 'Suspended on {{date}}. Downloads and AI generations are unavailable. Please contact support for assistance.',
        description_no_date: 'Downloads and AI generations are unavailable. Please contact support for assistance.',
        action: 'Contact support',
      },
      pending_cancel: {
        title: 'Your access will remain active until {{date}}',
        description: "You won't be charged again after this date. Downloads and AI generations stay available until then.",
      },
      ended: {
        title: 'Your subscription ended on {{date}}',
        description: 'Access is no longer active. Models you downloaded while subscribed stay licensed.',
      },
    },
    title: 'Subscription Management',
    subtitle: 'View your subscription status, limits, and renewal information',
    empty_state: {
      message: "You don't have an active Subscription",
      view_essentials: 'View Essentials',
      view_essentials_premium: 'View Essentials & Premium plans',
      plans_restructure: {
        title: "You don't have a subscription",
        intro: 'Subscribe to download up to {{downloads}} models a month from the subscription catalog. Monthly plans have no commitment; annual plans are paid upfront with 2 months free.',
        names: {
          essentials: 'Essentials',
          premium: 'Premium',
        },
        price_line: '/month · or {{annualPrice}}/year',
        cta: 'Get {{plan}}',
      },
    },
    active: {
      badge_active: 'Active',
      renews_monthly: '{{plan}} — Renews monthly, next on {{date}}',
      renews_annual: '{{plan}} — Paid upfront, renews on {{date}}',
      price_per_month: '{{price}} / month',
      price_per_year: '{{price}} / year',
      plan_name: {
        essentials: 'CGTrader Essentials',
        premium: 'CGTrader Premium',
        ai_studio: 'CGTrader AI',
      },
      badge_cancelled: 'Cancelled',
      cancel_button: 'Cancel subscription',
      renew_button: 'Renew subscription',
      reactivate_button: 'Reactivate subscription',
      annual_plan: 'Annual Plan',
      monthly_plan: 'Monthly Plan',
      renewal_message_prefix: 'Your subscription will automatically renew on ',
      renewal_message_suffix: '',
      monthly_renewal_message: 'Your subscription renews monthly',
      monthly_renewal_message_ai: 'Renews monthly, next on {{date}}',
      switch_plan: 'Switch plan',
      billing: {
        billing_cycle: 'Billing cycle',
        next_billing_date: 'Next billing date',
        no_renewal: 'No further charges',
        billing_suspended: 'Billing suspended',
        auto_resume: '{{date}} (auto-resume)',
        pauses_on: 'Pauses on {{date}}',
        price: 'Price',
        payment_method: 'Payment method',
        update: 'Update',
      },
      usage: {
        left: 'Left this month',
        downloads: '{{count}} download',
        downloads_plural: '{{count}} downloads',
        left_amount: '{{downloads}} or {{generations}}',
        generations: '{{count}} AI generation',
        generations_plural: '{{count}} AI generations',
        allowance_note: "Downloads and AI generations share one allowance: {{downloads}} downloads or up to {{generations}} AI generations a month, or any mix. Unused allowance doesn't carry over.",
        used_up_title: "You've used this month's allowance",
        renews_on: 'Your allowance renews on {{date}}.',
        ai_generations_used: 'AI generations used',
        progress_label_ai: '{{used}} of {{limit}} AI generations used',
        description_ai: "{{limit}} AI generations per billing period. The allowance resets on successful renewal — unused generations don't carry over.",
        no_marketplace_downloads: 'No marketplace downloads on this plan.',
        header: 'SUBSCRIPTION USAGE',
        models_downloaded: 'Models downloaded',
        progress_label: '{{used}} of {{limit}} models downloaded',
        reset_date: 'Reset date:',
        resets_on: 'Resets on {{date}}',
        available_until: 'Available until {{date}}',
        no_reset_date: 'No reset date',
        paused_tooltip: "You can't download models while your subscription is paused. Resume to download again.",
        paused_tooltip_ai: "You can't start new AI generations while your subscription is paused. Resume to generate again.",
        description: 'Your subscription includes a monthly limit to ensure <a href="https://www.cgtrader.com/pages/subscription-fair-use-policy" target="_blank" rel="noreferrer" class="cgt-legacy-link cgt-legacy-text-tiny">fair access</a> for all subscribers.',
      },
      cancel_info: {
        no_generations: "After cancellation, you won't be able to start new AI generations",
        keep_license_ai: "Models you've already generated remain licensed for your use on the projects that have been completed when the subscription was active",
        no_fee_no_commitment: 'No cancellation fee — CGTrader AI has no commitment, so you can cancel anytime',
        title: 'What happens if I cancel?',
        keep_access: "You will keep access until the end of already paid period",
        no_downloads: "After cancellation, you won't be able to download new models",
        keep_license: "Models you've already downloaded remain licensed for your use on the projects that have been completed when the subscription was active",
        cancellation_fee: "Cancellation fee does not apply if you cancel within the first 45 days. After this period, you will be charged 50% of the remaining balance of your contract obligation as a cancellation fee.",
        cancellation_fee_new_yearly: "Cancelling your subscription will incur a 50% early cancellation fee of the remaining contract balance. You will retain access for the period covered by the fee.",
      },
    },
    cancel_modal: {
      fee_free: {
        title: 'Cancel your subscription?',
        reason_label: "Tell us why you're cancelling",
        keep_button: 'Keep subscription',
        submit_button: 'Cancel subscription',
        consequences: {
          title: 'What happens if I cancel?',
          keep_access_month: 'You keep {{plan}} until {{date}}, the end of your paid month.',
          keep_access_year: 'You keep {{plan}} until {{date}}, the end of your paid year.',
          no_access_after: "After that, you can't download new models or start AI generations.",
          keep_license: "Models you've already downloaded stay licensed for projects completed while your subscription was active.",
          no_refund_annual: "Annual payments aren't refunded.",
          ends_now: "Your subscription ends right away. Your pause stops, and you can't download new models, re-download models you got with the subscription, or start AI generations.",
        },
      },
      save_offers: {
        another_option: 'Another option',
        reframe: {
          title: "You're getting more than you pay for",
          body: "You've downloaded {{count}} model this month. Bought individually, it'd cost about {{value}}. Your plan costs {{monthlyCost}} a month.",
          body_plural: "You've downloaded {{count}} models this month. Bought individually, they'd cost about {{value}}. Your plan costs {{monthlyCost}} a month.",
          individual_label: 'bought individually',
          plan_label: 'your plan a month',
          vs: 'vs',
          action: 'Keep my subscription',
          alt_text: '{{count}} download ≈ {{value}} bought individually',
          alt_text_plural: '{{count}} downloads ≈ {{value}} bought individually',
          alt_action: 'Keep plan',
        },
        downgrade: {
          title: 'Pay less: switch to Essentials',
          body_month: 'Keep your subscription for {{essentialsPrice}} instead of {{currentPrice}}. The change starts when your current month ends, on {{date}}.',
          body_year: 'Keep your subscription for {{essentialsPrice}} instead of {{currentPrice}}. The change starts when your current year ends, on {{date}}.',
          action: 'Downgrade to Essentials',
          alt_text: 'Pay less: switch to Essentials at {{essentialsPrice}}',
        },
        more: {
          title: "Before you go, there's more to explore",
          body: 'These can help you find the right models faster.',
          upgrade: {
            title: 'Upgrade to Premium',
            description: 'Unlock {{modelCount}}+ models, including premium assets, and up to {{generations}} AI generations a month.',
            action: 'Get Premium',
          },
          collections: {
            title: 'Curated collections',
            description: 'Hand-picked model sets for your field.',
            action: 'Browse',
          },
        },
      },
      no_fee_description_ai: "Your access and remaining AI generations continue until {{date}}. You won't be charged on that date.",
      title: 'Cancel Subscription',
      reason_label: 'Tell us why are you cancelling?',
      reason_placeholder: 'Select a reason...',
      submit_button: 'Cancel Subscription',
      reasons: {
        generations_not_good_enough: "The generated models weren't good enough",
        no_longer_need: 'I no longer need 3D models right now',
        short_term_project: 'I only needed it for a short-term project',
        not_enough_models: "I didn't find enough relevant models",
        not_worth_price: "The subscription wasn't worth the price",
        not_used_enough: "I didn't use it enough",
        prefer_individual: 'I prefer buying models individually',
        other: 'Other',
      },
      other_label: 'Please specify',
      other_placeholder: 'Please tell us more...',
      banner_description: "Your access will remain active until {{date}}. You won't be charged again after this date.",
      loading_fee: 'Loading cancellation details...',
      fee_error: 'Unable to load cancellation fee details. Please close and try again.',
      fee_title: 'Cancellation fee: {{fee}}',
      fee_description: 'Your access will remain active until {{date}}. A cancellation fee will be charged to your payment method.',
      no_fee_description: "Your access will remain active until {{date}}. You won't be charged a cancellation fee.",
      access_until_description: 'Your access will remain active until {{date}}.',
      fee_title_header: 'Confirm early cancellation',
      fee_warning_banner: 'Cancelling will incur a <strong>50% early cancellation fee</strong>.',
      consequences_title: "Before you go — here's what happens if you cancel",
      consequences: {
        no_generations: "After cancellation, you won't be able to start new AI generations.",
        keep_license_ai: 'Models you already generated remain licensed for use on projects completed while your subscription was active.',
        no_fee_no_commitment: 'No cancellation fee — CGTrader AI has no commitment, so you can cancel anytime.',
        keep_access: 'You will keep access until the end of your already-paid period.',
        no_downloads: "After cancellation, you won't be able to download new models.",
        keep_license: 'Models you already downloaded remain licensed for use on projects completed while your subscription was active.',
        fee_notice: "No cancellation fee applies if you cancel within the first 45 days. After that, you'll be charged 50% of the remaining balance of your contract obligation.",
        fee_notice_new_yearly: 'Cancelling your subscription will incur a 50% early cancellation fee of the remaining contract balance. You will retain access for the period covered by the fee.',
      },
      remaining_months: 'Remaining months',
      monthly_rate: 'Monthly rate',
      total_remaining: 'Total remaining',
      cancellation_fee_percent: '50% cancellation fee',
      calculated_active_period: 'Your calculated active period',
      contract_commitment_value: 'Contract commitment value:',
      cancellation_fee_summary: 'Cancellation fee (50%):',
      acknowledge_checkbox: 'I understand the fee and wish to proceed with cancellation',
      keep_subscription_button: 'Keep Subscription',
      back_button: 'Back',
      continue_button: 'Continue to cancel',
      success: 'Your subscription has been cancelled successfully.',
      error: 'Failed to cancel subscription. Please try again.',
      confirmation: {
        title_ended: 'Your subscription has ended',
        body_ended: "Your pause was stopped and your subscription ended today. Models you've already downloaded stay licensed.",
        title_ai: 'Cancellation scheduled for {{date}}',
        body_no_fee_ai: "You'll keep access and your remaining AI generations until {{date}}. After that you won't be able to start new AI generations, but everything you've already generated stays licensed. No cancellation fee was charged.",
        body_no_fee_no_date_ai: "After your current period ends you won't be able to start new AI generations, but everything you've already generated stays licensed. No cancellation fee was charged.",
        header: 'Subscription cancelled',
        title: 'Your subscription has been cancelled',
        body_no_fee: "You'll keep access until {{date}}. After that you won't be able to download new models, but everything you've already downloaded stays licensed. No cancellation fee was charged.",
        body_no_fee_no_date: "After your current period ends you won't be able to download new models, but everything you've already downloaded stays licensed. No cancellation fee was charged.",
        body_fee: "You'll keep access until {{date}}. A 50% early cancellation fee of {{fee}} has been charged. Models you've already downloaded stay licensed.",
        done_button: 'Done',
      },
    },
    paused: {
      notice_title: 'Paused until {{date}}',
      notice_description: "New downloads and AI generations are unavailable while paused — models you've downloaded before are still available. Plan changes are unavailable. Billing restarts on {{date}}. Your price stays at {{price}} when you resume, and models you've downloaded stay licensed.",
      resume_now: 'Resume now',
      usage_title: 'Paused until {{date}}',
      usage_description: "New downloads and AI generations are unavailable while paused — models you've downloaded before are still available. A fresh allowance starts when it resumes.",
      badge_paused: 'Paused',
      badge_scheduled: 'Pause scheduled',
      resume_button: 'Resume Subscription',
      cancel_scheduled_pause_button: 'Cancel scheduled pause',
    },
    pause_offer: {
      hero_amount: '$0',
      hero_caption: 'billed while paused',
      title: "Take a break — don't cancel",
      description: "Pause starts after your current period ends. You can resume subscription whenever you're ready, or it will resume automatically after 1 month.",
      benefits: {
        no_extra_charges: 'No extra charges',
        downloads_licensed: 'Downloads stay licensed',
        resume_anytime: 'Resume anytime',
      },
      pause_button: 'Pause my subscription',
      pause_button_one_month: 'Pause for 1 month',
      continue_to_cancel: 'Continue to cancel',
    },
    pause_confirmation: {
      header: 'Pause scheduled',
      title: 'Your subscription will pause',
      description: "You'll finish the period you've paid for, then pause on {{date}}. You won't be billed while paused. Resume anytime — or it resumes automatically after 1 month.",
      description_no_date: "You'll finish the period you've paid for, then your subscription will pause. You won't be billed while paused. Resume anytime — or it resumes automatically after 1 month.",
      done_button: 'Done',
    },
    pause: {
      errors: {
        generic: 'Something went wrong. Please refresh the page and try again.',
        subscription_not_found: "We couldn't find this subscription. Please refresh the page.",
        subscription_cannot_be_paused: "This subscription can't be paused right now. Please refresh the page.",
        subscription_pause_already_scheduled: 'A pause is already scheduled for this subscription. Please refresh the page.',
        subscription_billing_period_unavailable: "We couldn't schedule your pause. Please try again later or contact support.",
        subscription_pause_start_must_be_future: 'Your renewal is currently processing. Please try again once it completes.',
        user_pause_allowance_exhausted: "You've already used the maximum pause time for this subscription.",
        subscription_cannot_be_resumed: "This subscription can't be resumed. Please refresh the page.",
        solidgate_request_failed: "Something went wrong on our payment provider's side. Please refresh the page and try again.",
      },
    },
    billing_cycle: {
      yearly: 'Yearly',
      monthly: 'Monthly',
    },
    switch_plan_section: {
      price_unit: '/month',
      tags: {
        yearly: 'SAVE 60%',
        monthly: 'CANCEL ANYTIME',
      },
    },
    switch_plan_modal: {
      title: 'Switch plan',
      cancel: 'Cancel',
      current_plan: 'Current plan',
      submit: {
        to_yearly: 'Switch to Annual plan',
        to_monthly: 'Switch to Monthly plan',
      },
      notice: {
        yearly_to_monthly: 'Your plan will switch to Monthly at the end of your current annual commitment on {{date}}. No action needed until then.',
        monthly_to_yearly: 'Your plan will switch to Annual immediately. A new 12-month commitment starts today. Early cancellation fees apply after the first billing.',
      },
      plan: {
        yearly: {
          name: 'Annual plan',
          subtitle: 'billed monthly',
        },
        monthly: {
          name: 'Monthly plan',
          subtitle: 'no commitment',
        },
      },
      toast: {
        success: 'Your plan switch has been scheduled.',
        error: "We couldn't schedule your plan switch. Please try again.",
        upgrade_in_progress: 'Your upgrade is still being applied. Please try again in a few minutes.',
        renewal_in_progress: 'Your plan is renewing right now. Please try again in about an hour.',
      },
      preview_toast_error: "We couldn't load the plan details. Please try again.",
    },
    scheduled_switch_banner: {
      title: 'Plan change scheduled',
      description_prefix: "You'll move to the",
      description_on: 'on',
      description_suffix: '. You keep your annual benefits and {{price}} rate until then.',
      cancel_button: 'Cancel scheduled change',
      cancel_success: 'Scheduled plan change has been cancelled.',
      cancel_error: 'Failed to cancel scheduled plan change. Please try again.',
    },
    restore: {
      success: 'Your subscription has been restored successfully.',
      error: 'Failed to restore subscription. Please try again.',
    },
    retry_payment: {
      button: 'Retry payment',
      button_loading: 'Retrying...',
      helper_text: 'Already resolved the issue with your bank? Retry the charge without changing your card.',
      processing: {
        title: 'Payment retry in progress',
        description: "We've received your request. Your payment can take some time to process - we'll email you once it completes.",
      },
      error: {
        default: 'Payment failed again. Please update your payment method or try again later.',
      },
    },
    status_banners: {
      pause_scheduled: {
        title: 'Your subscription will pause on {{date}}.',
        description: "Access remains active until the end of the current cycle. You won't be billed once it's paused, and you can resume anytime.",
      },
      paused: {
        title: 'Your subscription is paused.',
        description: "You won't be billed while paused. Resume anytime from this page.",
        description_operational: "You won't be billed while paused.",
      },
      resume_requested: {
        title: 'Resume requested',
        description: "We're resuming your subscription — this can take a moment. Refresh the page to see the updated status.",
      },
      past_due: {
        title: 'Payment issue - update payment method',
        description: "Your last payment attempt failed. We'll retry automatically on {{date}}. Your access is temporarily preserved during this grace period.",
      },
      redemption: {
        title: 'Payment issue \u2014 update payment method',
        description: "Your last payment attempt failed. We'll retry automatically or you can update the payment method to retry now.",
      },
      cancelled: {
        description: "Your access will remain active until {{date}}. You won't be charged again after this date.",
      },
      ended: {
        description: 'Your Subscription ended on {{date}}. Access is no longer active.',
      },
      suspended: {
        title: 'Your subscription has been suspended',
        description: 'Suspended on {{date}}. Please',
        description_no_date: 'Please',
        contact_link: 'contact',
        description_suffix: 'support for assistance.',
      },
    },
    payment_history: {
      title: 'Payment history',
      download: 'Download',
      download_error: 'Invoice download failed. Please try again later.',
      columns: {
        amount_paid: 'Amount paid',
        tax_amount: 'Tax amount (VAT)',
        currency: 'Currency',
        payment_date: 'Payment date/time',
        status: 'Status',
        invoice: 'Invoice',
        payment_method: 'Payment method',
        billing_period: 'Billing period covered',
      },
      status: {
        paid: 'Paid',
        pending: 'Pending',
        failed: 'Failed',
      },
    },
  },
  subscription_checkout: {
    title: 'Choose a way to pay',
    subtitle: 'Pay securely using Apple Pay, Google Pay, PayPal, or a credit card.',
    divider_text: 'Or',
    credit_card_button: 'Pay by credit / debit card',
    terms: {
      title: 'You are enrolling in an annual subscription to CGTrader service.',
      body_start: 'You agree to be billed {{price}} per month until the end of the contract or cancellation of the subscription. Payments will be charged to your selected payment method. To cancel, go to Account Settings → Subscription Management, or see our <a href="https://www.cgtrader.com/pages/terms-and-conditions" target="_blank" class="cgt-legacy-link">Cancellation Policy</a>. ',
      body_end: 'Please note, that annual plan has an early cancellation fee.',
      annual: {
        title: 'Annual Subscription Terms (Billed Monthly)',
        body: 'You are enrolling in an annual subscription to CGTrader. You agree to be billed {{price}}/month plus applicable taxes until the end of the contract or cancellation. You can cancel anytime. If you cancel within the first 45 days, there\'s no early cancellation fee. After that, a fee may apply. To cancel, go to Account Settings → Subscription Management, or see our <a href="https://www.cgtrader.com/pages/terms-and-conditions" target="_blank" rel="noreferrer" class="cgt-legacy-link">Cancellation Policy</a>.',
      },
      monthly: {
        title: 'Monthly Subscription Terms',
        body: 'You are enrolling in a monthly subscription to CGTrader. You agree to be billed {{price}}/month. Cancel anytime from Account Settings → Subscription Management with no fees.',
      },
    },
    plan_selector: {
      section_title: 'Choose plan',
      names: {
        yearly: 'Annual plan',
        monthly:        'Monthly plan',
      },
      subtitles: {
        billed_monthly: 'billed monthly',
        no_commitment: 'no commitment',
      },
      badges: {
        save_60:        'Save 60%',
        cancel_anytime: 'Cancel anytime',
      },
      select_aria: 'Select {{name}}',
    },
    plans_restructure: {
      plan_card: {
        names: {
          essentials: 'CGTrader Essentials',
          premium: 'CGTrader Premium',
        },
        terms: {
          monthly: 'monthly plan, no commitment',
          annual: 'annual plan, paid upfront',
        },
        per_term: {
          monthly: '/month',
          annual: '/year',
        },
        features: {
          essentials: {
            first: '{{downloads}} downloads or up to {{generations}} AI generations a month, or any mix',
            second: 'Essentials catalog of {{modelCount}}+ models',
            third: 'Royalty-free license, no AI',
          },
          premium: {
            first: '{{downloads}} downloads or up to {{generations}} AI generations a month, or any mix',
            second: 'Premium catalog of {{modelCount}}+ models',
            third: 'Royalty-free license, no AI',
          },
        },
      },
      billing_term: {
        title: 'Billing term',
        summary: '{{plan}} · {{price}}, {{term}}.',
        change: 'Change',
        price: {
          monthly: '{{price}}/month',
          annual: '{{price}}/year',
        },
        free_months: '{{months}} months free',
        plans: {
          monthly: {
            name: 'Monthly plan',
            note: 'No commitment, cancel anytime',
            term: 'no commitment',
          },
          annual: {
            name: 'Annual plan',
            note: 'Paid upfront, billed once a year',
            term: 'billed once a year',
          },
        },
      },
      order_summary: {
        amount_due_today: 'Amount due today',
        next_billing: '*Next billing at {{price}}/month',
        renews_at: '*Renews at {{price}}/year',
        legal_privacy_separator: ',',
        legal_fair_use_connector: 'and',
        legal_fair_use: 'Subscription Fair Use Policy',
      },
      terms: {
        monthly: {
          title: 'Monthly Subscription Terms',
          body: 'You agree to be billed {{price}} per month until cancellation. Payments will be charged to your selected payment method. To cancel, go to Account Settings → Subscription Management, or see our <a href="https://www.cgtrader.com/pages/terms-and-conditions" target="_blank" rel="noreferrer" class="cgt-legacy-link">Cancellation Policy</a>. Cancel anytime — no fee.',
        },
        annual: {
          title: 'Annual Subscription Terms (Paid Upfront)',
          body: 'You agree to be billed {{price}} once a year, renewing automatically until cancellation. Payments will be charged to your selected payment method. To cancel, go to Account Settings → Subscription Management, or see our <a href="https://www.cgtrader.com/pages/terms-and-conditions" target="_blank" rel="noreferrer" class="cgt-legacy-link">Cancellation Policy</a>. Cancel anytime — you keep access until the end of the paid year. Annual payments are not refunded.',
        },
      },
      upgrade: {
        banner: {
          lead_upgrade: 'Upgrading from Essentials.',
          lead_upgrade_from_annual: 'Upgrading from Essentials annual.',
          lead_switch_to_annual: {
            essentials: 'Switching Essentials to annual billing.',
            premium: 'Switching Premium to annual billing.',
          },
          used_prefix: 'You\'ve used',
          used_of_total: '{{used}} of {{total}}',
          period_month: 'downloads this month, so we credit the',
          period_annual: 'downloads of your annual term, so we credit the',
          unused: '{{unused}} unused',
          suffix: 'back toward today\'s charge.',
          new_term: 'Your new annual term starts today.',
        },
        subtotal: {
          premium: 'Premium subtotal',
          essentials: 'Essentials subtotal',
        },
        credit: {
          essentials: {
            monthly: 'Essentials monthly credit',
            annual: 'Essentials annual credit',
          },
          premium: {
            monthly: 'Premium monthly credit',
          },
        },
        credit_basis: {
          monthly: '{{unused}} of {{total}} downloads unused',
          annual: '{{unused}} of {{total}} downloads unused in the annual term',
        },
        cta: {
          switch_to_annual: {
            essentials: 'Switch to Essentials annual for {{amount}}',
            premium: 'Switch to Premium annual for {{amount}}',
          },
          upgrade: {
            monthly: 'Upgrade to Premium for {{amount}}',
            annual: 'Upgrade to Premium annual for {{amount}}',
          },
        },
        page_errors: {
          no_active_subscription: "You don't have an active subscription to upgrade.",
          payment_failed: 'Your last payment failed. Update your payment method before upgrading.',
          subscription_paused: 'Your subscription is paused. Resume it before upgrading.',
          subscription_suspended: 'Your subscription is suspended. Please contact support.',
          scheduled_for_cancellation: "Your subscription is scheduled to cancel, so it can't be upgraded right now.",
          scheduled_change_pending: 'You already have a plan change scheduled. Keep your current plan to upgrade instead.',
          renewal_in_progress: 'Your plan is renewing right now. Please try again in about an hour.',
          no_upgrade_available: "There's no upgrade available for your current plan.",
        },
        commit_errors: {
          quote_changed: 'The amount due has changed. Review the new total and confirm again.',
          upgrade_failed: "We couldn't confirm your upgrade. Please contact support before trying again.",
          target_not_allowed: 'This upgrade is no longer available. Review the options and try again.',
        },
      },
    },
    payment_success_processing: 'Processing the payment. Please wait…',
    payment_retry_button: 'Try again',
    payment_success_toast: 'Payment details saved successfully.',
    payment_error_toast: 'Payment failed. Please try again.',
    intent_update_error: "We couldn't update your order. Please try again.",
    update_title: 'Update payment method',
    update_subtitle: 'Update your payment details securely.',
    update_credit_card_button: 'Credit / Debit Card',
    update_save_button: 'Save',
    update_cancel_button: 'Cancel',
    order_summary: {
      title: 'Order Summary',
      item_context: {
        sub_label: 'Available to download after subscribing',
      },
      billing_period: '1 year at',
      price_unit: '/month',
      subtotal: 'Subtotal',
      vat_included: 'Value Added Tax',
      vat_tooltip: 'Value Added Tax (VAT), also known as Sales tax or Goods and services tax (GST), is a tax applied at the point of sale to the end buyer and paid to the government of the buyer\'s country.',
      amount_due_today: 'Order Total',
      pay_button: 'Subscribe for {{amount}}',
      pay_button_upgrade: 'Pay {{amount}} & Upgrade',
      premium_renewal_note: 'Premium unlocks immediately – then {{price}}/month from {{date}}',
      legal_agreement_prefix: 'By continuing I agree to the',
      legal_agreement_terms: 'General Terms & Conditions',
      legal_agreement_privacy: 'Privacy Policy',
      legal_agreement_connector: 'and',
      plans: {
        yearly: {
          name:           'CGTrader Essentials Subscription — annual plan, billed monthly',
          billing_period: '1 year at',
          price_unit:     '/month',
          features: {
            first:  '25 assets / month — download models or generate with AI',
            second: 'Instant access to {{modelCount}}+ essential 3D models',
            third:  'Royalty-free, No AI',
          },
        },
        monthly: {
          name:           'CGTrader Essentials — monthly plan',
          billing_period: '',
          price_unit:     '/month',
          features: {
            first:  '25 assets / month — download models or generate with AI',
            second: 'Instant access to {{modelCount}}+ essential 3D models',
            third:  'Royalty-free, No AI',
          },
        },
      },
    },
    company: {
      toggle_label: 'Purchase as a company',
      info_banner: 'Make sure you filled and applied company details.',
      company_name: 'Company name',
      company_code: 'Company code',
      vatin: 'Company tax number',
      vatin_tooltip: 'If your company is registered for VAT/GST/Sales or equivalent tax, please make sure to enter your tax number for validation (in some cases you might be eligible for 0% tax rate).',
      country: 'Country',
      state: 'State / Province',
      zip_code: 'Zip code',
      city: 'City',
      street_address: 'Street address',
      apply_button: 'Apply',
      applying: 'Applying...',
      update_button: 'Update',
      updating: 'Updating...',
      field_required: 'This field is required',
    },
    email_step: {
      title: 'Enter your email',
      subtitle: 'to continue with subscription',
      email_label: 'Email Address',
      email_placeholder: 'john@email.com',
      email_required: 'Email is required',
      email_invalid: 'Please enter a valid email address',
      helper_text: 'It will only be used for sending you transactional information.',
      continue_button: 'Continue',
      login_link_prefix: 'Already have an account?',
      login_link: 'Log in',
      divider: 'or',
    },
    captcha_step: {
      title: 'Quick security check',
      subtitle: 'Please complete the verification below to continue to payment.',
      continue_button: 'Continue',
      incomplete: 'Please complete the captcha to continue.',
      failed: 'Captcha verification failed. Please try again.',
    },
    login_step: {
      info_title: 'Looks like you already have an account',
      info_subtitle: 'Log in to continue',
      title: 'Welcome back',
      subtitle: 'Log in to complete your subscription',
      email_label: 'Email',
      password_label: 'Password',
      login_button: 'Log in and continue',
      forgot_password: 'Forgot password?',
      hide_password: 'Hide password',
      show_password: 'Show password',
    },
    guest_banner: {
      paying_as: 'Paying as',
      not_you: 'Not you?',
    },
    create_account: {
      notice_title: 'Payment successful - you are subscribed!',
      notice_body: 'Your {{plan}} subscription is now active. A confirmation has been sent to',
      notice_body_no_plan: 'Your subscription is now active. A confirmation has been sent to',
      title: 'One last step - create your account',
      subtitle: 'Set a password to log in, download your model, and manage your subscription.',
      email_label: 'Email',
      submit_button: 'Register and start downloading',
    },
  },
  extra_usage_checkout: {
    title: 'Choose a way to pay',
    subtitle: 'Pay securely using Apple Pay, Google Pay, or a credit card.',
    divider_text: 'Or',
    credit_card_button: 'Pay by credit / debit card',
    update_credit_card_button: 'Credit / Debit Card',
    payment_success_processing: 'Processing the payment. Please wait...',
    payment_retry_button: 'Try again',
    payment_success_toast: 'Extra Usage purchased successfully.',
    payment_error_toast: 'Payment failed. Please try again.',
    order_summary: {
      title: 'Order Summary',
      subtotal: 'Subtotal',
      vat_label: 'Value Added Tax',
      vat_tooltip: 'Value Added Tax (VAT), also known as Sales tax or Goods and services tax (GST), is a tax applied at the point of sale to the end buyer and paid to the government of the buyer\'s country.',
      order_total: 'Order Total',
      pay_button: 'Subscribe for {{amount}}',
      legal_prefix: 'By continuing I agree to the',
      legal_terms: 'General Terms & Conditions',
      legal_privacy: 'Privacy Policy',
      legal_connector: 'and',
    },
    terms: {
      title: 'Extra Usage Terms (one-time payment)',
      body: "Extra Usage don't expire or reset monthly. You'll need an active subscription to purchase and use it.",
      support_prefix: 'If you have any questions or need help, contact us at',
    },
  },
  subscription_item_page: {
    subscribe_cta: 'Subscribe and save',
    purchase_options_label: 'Purchase options',
    upgrade_cta: 'Upgrade plan',
    redownload_note: 'Downloaded with your subscription. Download it again from My purchases.',
    resubscribe_prompt: 'Resubscribe to re-download your models',
    plans_restructure: {
      plan_labels: {
        essentials: 'Essentials',
        premium: 'Premium',
      },
      plan_names: {
        essentials: 'Essentials Subscription',
        premium: 'Premium Subscription',
      },
      bullets: {
        allowance: '{{downloads}} or up to {{generations}} a month',
        downloads: '{{value}} downloads',
        generations: '{{value}} AI generations',
        catalog: {
          essentials: 'Access a library of {{value}} models',
          premium: 'Access a library of {{value}}+ total accessible models',
          premium_upgrade: 'Access a library of {{value}}+ total accessible models, including this one',
        },
        license: 'Commercial Royalty free (No AI) license',
        pay_annually: 'Or pay yearly at checkout — {{months}}',
        months_free: '{{value}} months free',
      },
      value_line: '{{monthlyPrice}} monthly for {{downloads}} models - vs {{price}} for this single model.',
      learn_more: 'Learn more',
      included_note: 'Royalty-free license · all {{count}} formats · included with your {{plan}} plan',
      included_note_without_formats: 'Royalty-free license · included with your {{plan}} plan',
      upgrade_cta: 'Upgrade to Premium',
      upgrade_allowance_credited: 'Your Essentials allowance is credited when you upgrade.',
      paused_notice: {
        title: 'Paused until {{date}}',
        body: 'Resume your {{plan}} plan to download this model.',
        resume: 'Resume and download',
      },
      payment_failed_notice: {
        title: 'Update your payment method to download',
        body: 'Your last subscription payment didn\'t go through.',
        update_payment_method: 'Update payment method',
      },
      allowance_notice: {
        title: 'You\'ve used this month\'s allowance',
        body: 'Your {{plan}} allowance renews on {{date}}. You can still buy this model now.',
        body_without_date: 'You can still buy this model now.',
        manage: 'Manage subscription',
      },
      onetime: {
        title: 'One-time purchase',
        license_tag: 'Royalty-free',
        bullets: {
          license: 'Yours forever — royalty-free license',
          formats: 'All {{count}} file formats included',
          single_format: '1 file format included',
          instant_download: 'Instant download after purchase',
        },
      },
      free: {
        price: 'Free',
        download: 'Download',
        usage: 'Free for personal and commercial use',
      },
    },
  },
  subscription_upgrade: {
    explainer: {
      prefix: "Upgrading from Essentials. You've used",
      used_of_limit: '{{used}} of {{limit}}',
      middle: 'downloads this period, so we credit the',
      unused: '{{unused}} unused',
      suffix: "back toward today's charge.",
    },
    payment_method: {
      title: 'Payment method',
      subtitle: "We'll use the card saved to your account — no need to re-enter it.",
      saved_badge: 'Saved',
      use_different: 'Use a different payment method',
    },
    order_summary: {
      title: 'Order summary',
      plan_name: 'CGTrader Premium Subscription',
      plan_cadence: 'annual plan, billed monthly',
      billing_period: '1 year at',
      premium_price: 'Premium subtotal',
      credit_label: 'Essentials credit',
      credit_basis: '{{unused}} of {{limit}} downloads unused',
      vat_included: 'Value Added Tax',
      vat_tooltip: 'VAT is calculated based on your billing location.',
      amount_due_today: 'Amount due today',
      cta: 'Pay {{amount}} & Upgrade',
      next_billing_note: '*Next billing at {{price}}/month',
      legal_agreement_prefix: 'By continuing I agree to the',
      legal_agreement_terms: 'General Terms & Conditions',
      legal_agreement_privacy: 'Privacy Policy',
      legal_agreement_connector: 'and',
    },
  },
  my_subscriptions: {
    profile_header: {
      title: 'Subscription Settings',
      description: 'Manage your participation in the Essentials Program.',
      learn_more: 'Learn more',
    },
    status_card: {
      title: 'CGTrader Essentials',
      badge_participating: 'Participating',
      badge_not_participating: 'Not participating',
      description: 'The Essentials Subscription program allows users to access a curated library of models for a monthly fee.',
      participation_label: 'Participation:',
      participation_text: 'All eligible models will be included. Models cannot be selected individually.',
      revenue_share_label: 'Revenue Share:',
      revenue_share_text: 'Earnings are calculated based on your share of total subscription downloads from the monthly revenue pool.',
      manage_label: 'Manage participation anytime:',
      manage_text: 'Changes take effect shortly after updating your settings.',
      join_title: 'CGTrader Essentials is included in the Maximize Your Earnings program.',
      join_description: 'Get access to subscription income, revenue share, and custom enterprise opportunities.',
      join_button: 'Join the Maximize my earnings program',
    },
    tabs: {
      eligible_models: 'Eligible Models',
      earnings: 'Earnings',
    },
    eligible_models: {
      description_line1: 'View all your models eligible to earn subscription revenue.',
      description_line2: 'Your models remain active and available to subscribers until you choose to opt out.',
      column_models: 'Models',
      column_publishing_date: 'Publishing date',
      column_opt_in_date: 'Subscription opt-in date',
      empty_title: 'No models available',
      empty_description: 'You don\'t have any models eligible for CGTrader Essentials at the moment.',
    },
    join_modal: {
      title: 'CGTrader Subscriptions',
      title_legacy: 'Join the Maximize your earnings program',
      participating_pill: 'Participating in Maximize Earnings program',
      intro_heading: 'Enable Maximize Earnings to get started',
      intro_body: 'Unlock additional monetization opportunities designed to increase your long-term revenue. This program gives you access to:',
      intro_programs_essentials_label: 'CGTrader Essentials & Premium',
      intro_programs_essentials_text: '— Earn from monthly subscription downloads',
      intro_programs_enterprise_label: 'Enterprise & custom deals',
      intro_programs_enterprise_text: 'Participate in tailored B2B agreements',
      intro_programs_revenue_label: 'Revenue share opportunities',
      intro_programs_revenue_text: 'Benefit from strategic distribution partnerships',
      intro_programs_equity_label: 'Equity-based collaborations',
      intro_programs_equity_text: 'Exchange selected models for equity participation',
      intro_programs_other_label: 'Other alternative compensation models',
      intro_programs_other_text: 'as they become available',
      intro_inset_title: 'What happens when you join',
      intro_inset_models: 'Your eligible models become part of the program pool',
      intro_inset_earnings: 'You gain access to subscription-based earnings',
      intro_inset_opportunities: 'You may be considered for enterprise and alternative compensation opportunities',
      section_what_title: 'How subscriptions work',
      section_what_body: 'CGTrader offers two subscription tiers for buyers:',
      section_what_tier_essentials_label: 'Essentials',
      section_what_tier_essentials_text: '— $9.99/month, 25 downloads. Everyday assets.',
      section_what_tier_premium_label: 'Premium',
      section_what_tier_premium_text: '— $34.99/month, 25 downloads. Higher-end assets.',
      section_what_tiers_note: 'Your models are included in the tier that matches their category. A model may appear in one or both tiers. Unused downloads don\'t roll over.',
      section_earnings_title: 'How your earnings are calculated',
      section_earnings_body: 'Each month, CGTrader allocates a share of subscription revenue proportional to how many times your models were downloaded relative to all subscription downloads that month.',
      section_earnings_rule: 'One rule applies: each download earns you up to your model\'s listed price times your royalty rate - so if your model is priced at $5, you earn a maximum of $5 times your royalty rate per download.',
      section_earnings_timing: 'Earnings are calculated on the 1st of the following month and are never adjusted retroactively.',
      section_refunds_title: 'Refunds and chargebacks',
      section_refunds_body: 'If a subscriber is refunded, that payment is removed from the revenue pool in the month the refund occurs, not the original download month. In practice, refunds are rare and won\'t meaningfully affect your earnings.',
      section_optin_title: 'Opting in and out',
      section_optin_body: 'Models are added to the subscription catalog when Maximize Earnings is enabled (My Sales → Discounts). To remove your models, disable the setting. Past earnings are not affected.',
      join_cta: 'Join Maximize Earnings',
      description: 'Unlock additional monetization opportunities designed to increase your long-term revenue. This program gives you access to:',
      benefit_essentials_label: 'CGTrader Essentials',
      benefit_essentials_text: '– Earn from monthly subscription downloads',
      benefit_enterprise_label: 'Enterprise & custom deals',
      benefit_enterprise_text: '– Participate in tailored B2B agreements',
      benefit_revenue_label: 'Revenue share opportunities',
      benefit_revenue_text: '– Benefit from strategic distribution partnerships',
      benefit_equity_label: 'Equity-based collaborations',
      benefit_equity_text: '– Exchange selected models for equity participation',
      benefit_other_label: 'Other alternative compensation models',
      benefit_other_text: 'as they become available',
      info_box_title: 'What happens when you join:',
      info_box_essentials_name: 'CGTrader Essentials',
      info_box_essentials_suffix: 'is fully included as part of this program:',
      info_box_models: 'Your eligible models become part of the program pool',
      info_box_earnings: 'You gain access to subscription-based earnings',
      info_box_enterprise: 'You may be considered for enterprise and alternative compensation opportunities',
      confirm_button: 'Join the program',
      cancel_button: 'Cancel',
      got_it_button: 'Got it',
      success: 'You have successfully joined the Maximize your earnings program',
      error: 'Something went wrong. Please try again.',
    },
  },
  skills:{
    '3d-modeling': '3D Modeling',
    '3d-print-modeling': '3D Print Modeling',
    '3d-scanning': '3D Scanning',
    'animating': 'Animating',
    'grooming': 'Grooming',
    'lighting': 'Lighting',
    'low-poly-modeling': 'Low-poly Modeling',
    'particles': 'Particles',
    'pbr-modeling': 'PBR Modeling',
    'post-production': 'Post Production',
    'rendering': 'Rendering',
    'rigging': 'Rigging',
    'shaders': 'Shaders',
    'skinning': 'Skinning',
    'texturing': 'Texturing',
    'uv-mapping': 'UV mapping'
  },
  profilePage: {
    listings: '3D Models',
    reviews: 'Reviews',
    imageGallery: 'Image gallery',
    tutorials: 'Tutorials',
    rating: 'Rating',
    reputation: 'Reputation',
    responseRate: 'Response Rate',
    responseTime: 'Response Time',
    projectsDone: '3D Projects done',
    modelViews: 'Model Views',
    modelLikes: 'Model Likes',
    followers: 'Followers',
    software: '3D Software',
    skill: 'Skill',
    about: 'About',
    modelos: '3D Models',
    projects: '3D Projects',
    reviewsGiven: 'Reviews given',
    ratings: 'Ratings',
    positive: 'Positive',
    negative: 'Negative',
    priceLabel: 'Price',
    positiveFirst: 'Positive first',
    negativeFirst: 'Negative first',
    tooltipTextResponseRate: 'Percentage of received messages that the user has replied to',
    tooltipTextResponseTime: 'Average time in which the user replies to messages',
    tooltipTextProjectsDone: 'Count of successfully completed 3D Projects. Currently working on {{projectCount}} 3D Projects',
    tooltipTextModelViews: "Number of times designer's models were viewed",
    tooltipTextModelLikes: "Count of likes the designer's models have received",
    tooltipTextFollowers: 'Number of followers the designer has',
    noModelsUploaded: 'User has not uploaded any 3D models yet.',
    noModelsReviews: 'No 3D Model reviews yet.',
    noProjectsReviews: 'No 3D Project reviews yet.',
    loadMore: 'Load more',
    noArtworksUploaded: 'User has not uploaded any artworks yet.',
    noTutorialsUploaded: 'User has not published any tutorials yet.',
    seeAllModels: 'See all {{modelCount}} 3D models',
    viewAllModels: 'View all {{modelCount}} models'
  },
  navigation: {
    'aria': {
      'open_menu': 'Open menu',
      'close_menu': 'Close menu',
      'search': 'Search',
      'search_by_image': 'Search by image',
      'clear_search': 'Clear search',
      'cart': 'Cart',
      'messages': 'Messages',
      'notifications': 'Notifications',
      'account': 'Account',
      'account_with_plan': '{{name}}, {{plan}} plan',
      'logo': 'CGTrader - 3D Models / 3D Designers',
    },
    'get_subscription': 'Get subscription',
    navbar: {
      '3d_models': {
        'categories': 'Categories',
        'types': 'Type',
        'budget': 'Budget',
        'all_models': 'All Models',
        'browse_all': 'All 3D Models',
        'browse_all_print': 'All 3D Printing',
        'about': 'About 3D Models',
        'about_print': 'About 3D Printing',
      },
      'actions': {
        'new': 'New',
        'trending': 'Trending',
        'top_selling': 'Top Selling',
      },
      'budgets': {
        'below_10': 'Under $10',
        'up_to_10': 'Up to $10',
        'more_than_20': 'More than $20',
        'more_than_50': 'More than $50',
        'free': 'Free',
        'sale': 'On Sale',
      },
      'community': {
        'title': 'Community',
        'earn': 'Earn',
        'earn_with_cgtrader': 'Earn with CGTrader',
        'upload_3d_model': 'Upload 3D Model',
        'search_for_projects': 'Search for Projects',
        'freelance_on_cgtrader': 'Freelance on CGTrader',
      },
      'grow_your_sales': {
        'title': 'Grow Your Sales',
        'sell_more': 'Sell More 🚀',
        '3d_market_insights': '3D Market Insights',
        'top_model_searches': 'Top 3D Model Searches',
        'top_print_searches': 'Top 3D Print Searches',
      },
    },
    'search': {
      placeholder: 'Search over 2 million models',
      buttonText: 'Upload',
      uploading: 'Uploading...',
      dragAndDrop: 'Drag & drop image or',
      formats: 'JPG, PNG, and WEBP images under 25 MB.',
      immediatelyAfterUpload: 'We\'ll proceed with the search immediately after the image is uploaded.',
      advancedTips: {
        title: 'Search Tips & Tricks',
        intro: 'Use <em>advanced search syntax</em> to quickly find the perfect 3D model. The search works in both <em>Title</em> and <em>Tags</em>.',
        syntax: 'Syntax',
        example: 'Example',
        description: 'Description',
        exactPhrase: 'Only shows results that include the exact phrase <em>robot arm</em>.',
        hideResults: 'Hides results that contain the word <em>jewelry</em>.',
        onlyShowResults: 'Only shows results that must include the word <em>furniture</em>.',
        showResultsEither: 'Shows results that include either <em>car</em>, <em>truck</em>, or both.',
        showResultsBoth: 'Only shows results that include both <em>plane</em> and <em>military</em>.',
        showResultsStartsWith: 'Matches anything that starts with <em>robot</em>, like <em>robot</em>, <em>robotic</em>, <em>robotics</em>, etc.',
        showResultsThreeLetters: 'Matches any 3-letter word that starts with <em>p</em> and ends with <em>n</em>, like <em>pan</em>, <em>pen</em>, or <em>pin</em>.',
      }
    },
    'user': {
      login: 'Log in',
      register: 'Sign up',
    },
    'projects': {
      seller_perspective: 'Freelance 3D Projects',
      browse: 'Browse Projects',
      start: 'Start a Project',
      about: 'About 3D Projects',
      work: 'Work with CGTrader',
      my_projects: 'My Projects',
      buyer_perspective: 'Hire 3D Designers',
    },
    '3d-models': {
      'title': '3D Models',
      '3d-printing': '3D Print Ready',
      'pbr': 'PBR',
      'vr_low-poly': 'Low-poly',
      'scanned_3d-models': 'Scanned 3D Models',
      'find_designers': 'Best designers',
      'discounts': 'Discounts',
      'scripts_apps': 'Scripts & Apps',
      'textures': 'CG Textures',
      'show-all': 'Show all',
      'free': 'Free',
    },
    'sell_3d-models': 'Sell 3D Models',
    'enterprise': {
      title: '3D Content Production',
      management: '3D Asset Management',
    },
    'credits_guest_widget': {
      'get': ' and get up to ',
      'create': 'Create an account now!',
      'learn_more': 'Learn more about CGTrader Points ',
      'link': 'here',
      'text_below_1': 'Points can be used when purchasing "',
      'text_below_2':
        '" sign marked models and cover up to 30% discount of the price.',
      'sign-up': 'Sign up',
      'discount': ' discount',
      'for': ' for your ',
      'purchase': 'first purchase!',
    },
    'tooltips': {
      discounts: 'CGTrader Points',
      cart: 'Shopping Cart',
      conversations: 'My Conversations',
      notifications: 'Notifications',
      publisher: 'Publisher',
    },
    'cart_widget': {
      title: 'Cart',
      subtitle: 'The Cart is Empty',
      text: 'Start exploring and fill your cart with awesome finds!',
      have: 'You have ',
      items: ' items in your shopping cart.',
      total: 'Total: ',
      remainer: 'To activate CGTrader Points add: ',
      used: 'CGTrader Points used: ',
      discount: 'Discount with enterprise coupon: ',
      sale_time_left: 'Sale ends in',
      sale_discounts: 'Discounts applied: ',
      final: 'Final price: ',
      proceed: 'Proceed to checkout',
      view: ' View cart',
      wishlist_tab: 'Wishlist items',
      recently_viewed_tab: 'Recently viewed',
      sale_tooltip: 'Discounts from our Sale-Off campaigns are only applied when your cart reaches ${{threshold}} or more.',
      left_to_unlock_discounts: '{{leftToUnlock}} Left to unlock discounts',
      sale_tooltip_text: 'This item is on sale, but the discount will only be applied once your cart subtotal reaches ${{threshold}} or more.',
      potential_discount: 'Potential discount:',
      discount_applied: 'Discounts applied:',
      wishlist_empty_title: 'Your wishlist is empty',
      wishlist_empty_text: 'Start exploring and save your favorites for later — they’ll show up here.',
      recently_viewed_empty_title: 'Nothing here yet',
      recently_viewed_empty_text: 'Start exploring and your recently viewed items will appear here.',
      continue_shopping: 'Continue shopping',
    },
    'community': {
      'title': 'Community',
      'galleries': 'Galleries',
      'tutorials': 'Tutorials',
      'forum': 'Forum',
      'designers': 'Designers',
      'challenges': 'Challenges',
      'digital_art': 'Digital Art Competition',
      'blog': 'Blog',
      'community_ratings': 'Community ratings',
      'sell_3d-models': 'Sell 3D Models',
      'printlist': '3D PrintList',
      'invite': 'Invite a friend',
    },
    'credits_user_widget': {
      title: 'CGTrader Points',
      par_1: 'You have ',
      par_2: ' CGTrader points.',
      par_2_variation:
        ' in Points that you can spend when no sale off is available.',
      notice:
        '<strong>NOTE:</strong> CGTrader Points cannot be used during the ongoing sale, but they will be available again once the sale ends. In the meantime, check out great deals on 3D models <a href="https://www.cgtrader.com/3d-models?sale_off=1">here</a>',
      first_text_1:
        'Consider it a gift for your first purchase - you can use points when purchasing " ',
      first_text_2:
        ' " marked models and get up to 30% discount of it\'s price. Points can only be used if the total value of your cart is equal to or greater than',
      regular_text_1: 'Points can be used when purchasing " ',
      regular_text_2:
        ' " sign marked models and cover up to 30% discount of it\'s price.',
      important: 'IMPORTANT:',
      message:
        ' Points cannot be used during Sale campaigns, but you can still increase your loyalty level and collect more points for your next purchase.',
      more_credits: 'How do I get more points?',
      list_item:
        'By increasing your lifetime spending on CGTrader, your Points earn rate increases as well.',
      learn_more: 'Learn more',
      earn_rate: 'Points earn rate ',
      lifetime_spending: 'Lifetime spending: ',
      next_level: 'Next level: ',
      condition_1:
        'CGTrader Points can be applied toward the purchase of models marked with the <i class="custom-font-icon custom-font-icon--small icon-wallet"></i> sign, providing up to a 30% discount off their price.',
      condition_2:
        "Points can only be used if your cart's total value is <strong>${{minimum}}</strong> or more.",
      condition_3: 'During active sales or promotions, points cannot be used.',
      condition_4:
        '<strong>Keep in mind</strong> that points have an expiration date - your points will expire in <strong>{{days}}</strong> days.',
    },
    'item_add_message': 'has successfully been added to the cart',
    'already_added_message': 'has already been added to the cart',
    'conversations_widget': {
      messages: {
        loading: 'Loading inbox',
      },
      conversations: 'Conversations',
      types: {
        personal: 'Personal Message',
        offer: 'Price Offer',
        cgtrader_support: 'CGTrader Support',
        model_support: 'Model Support',
        job_application: '3D Project',
        file_conversion_request: 'File conversion request',
        model_feedback: 'Product Feedback',
        promotions: 'Promotions',
      },
    },
    'user_menu': {
      gdpr_notice: {
        message: 'You need to review your {{link}}',
        link: 'email notification preferences',
      },
      dashboard: 'Admin Dashboard',
      settings: 'Account Settings',
      public_profile: 'Public Profile',
      logout: 'Log out',
      seller: {
        publishing: 'Upload 3D Model',
        models: 'My Models',
        sales: 'My Sales',
        subscription: 'Subscription',
        analytics: 'Analytics',
        freelance: 'My 3D Projects',
        wishlist: '3D Model Wishlist',
        freelance_cgtrader: 'Freelance with CGTrader',
        publish_project: 'Post a Project',
        find_new_projects: 'Find New 3D Projects',
      },
      buyer: {
        purchases: 'My Purchases',
        wishlist: '3D Model Wishlist',
        freelancers: 'Find Freelancers',
        sell: 'Sell 3D Models',
      },
    },
    'already_purchased_message': 'You have already purchased this item.',
    'cart_limit_reached':
      "You've reached the 500-item limit in your cart. To continue shopping, please complete your current order and start a new one for any additional items.",
  },
  'sale_off_bar': {
    'find_deals': 'Find deals',
  },
  'subscribe_bar': {
    'content_full': '25 models a month, starting from {{price}}',
    'content_short': '25 models a month, starting from {{price}}',
    'cta': 'Get Subscription',
  },
  'cgdream_notice_bar': {
    'message': 'Coming from CGDream? Image generation now lives here on CGTrader AI.',
    'dismiss': 'Dismiss notice',
  },
  footer: {
    'subscribe': {
      'header': 'Subscribe to our news:',
      'button-active': 'Subscribe',
      'button-disabled': 'Subscribed',
      'text': 'By subscribing you confirm that you have read and accept our',
      'terms-link': 'Terms of Use',
      'placeholder': 'Enter your email',
    },
    'links': {
      companyLinks: [
        {
          text: 'Company',
          link: '/discover/about-us',
        },
        {
          text: 'Blog',
          link: '/blog',
        },
        {
          text: 'Careers',
          link: '/pages/careers',
        },
        {
          text: 'Help Center',
          link: 'https://help.cgtrader.com',
        },
      ],
      buyLinks: [
        {
          text: 'Buy 3D Models',
          link: '/3d-models',
        },
        {
          text: 'For Business',
          link: '/discover/business-account',
        },
        {
          text: '3D Datasets',
          link: '/discover/datasets',
        },
        {
          text: 'Hire a 3D Designer',
          link: '/3d-modeling-jobs',
        },
        {
          text: 'Free 3D Models',
          link: '/free-3d-models',
        },
        {
          text: 'Free 3D Print Models',
          link: '/free-3d-print-models',
        },
      ],
      sellLinks: [
        {
          text: 'Sell 3D Models',
          link: '/discover/sell-3d-models',
        },
        {
          text: 'Grow your sales',
          link: '/discover/sell-more',
        },
        {
          text: '3D Market Insights',
          link: '/discover/3d-market-trends',
        },
        {
          text: 'Top 3D Model Searches',
          link: '/discover/3d-models-top-searches',
        },
        {
          text: 'Top 3D Print Searches',
          link: '/discover/3d-print-models-top-searches',
        },
      ],
      communityLinks: [
        {
          text: 'Community',
          link: '',
        },
        {
          text: 'Top designers',
          link: '/designers',
        },
        {
          text: 'Challenges',
          link: '/challenges',
        },
        {
          text: 'Forum',
          link: '/forum',
        },
      ],
      // enterpriseLinks: [
      //   {
      //     text: 'Modelry',
      //     link: 'https://www.modelry.ai/?utm_source=cgtrader_marketplace&utm_medium=referral&utm_campaign=marketplace_shop&utm_id=00001&utm_term=2210&utm_content=modelry&utm_creative_format=footer_menu&utm_marketing_tactic=marketplace_users&utm_source_platform=cgtrader',
      //   },
      //   {
      //     text: '3D Viewer',
      //     link: 'https://www.modelry.ai/3d-viewer?utm_source=cgtrader_marketplace&utm_medium=referral&utm_campaign=marketplace_shop&utm_id=00001&utm_term=2210&utm_content=3d_viewer&utm_creative_format=footer_menu&utm_marketing_tactic=marketplace_users&utm_source_platform=cgtrader',
      //   },
      //   {
      //     text: '3D Product Visualization',
      //     link: 'https://www.modelry.ai/3d-product-visualization?utm_source=cgtrader_marketplace&utm_medium=referral&utm_campaign=marketplace_shop&utm_id=00001&utm_term=2210&utm_content=3d_product_visualization&utm_creative_format=footer_menu&utm_marketing_tactic=marketplace_users&utm_source_platform=cgtrader',
      //   },
      //   {
      //     text: '3D Digital Asset Management',
      //     link: 'https://www.modelry.ai/3d-digital-asset-management?utm_source=cgtrader_marketplace&utm_medium=referral&utm_campaign=marketplace_shop&utm_id=00001&utm_term=2210&utm_content=3d_digital_asset_management&utm_creative_format=footer_menu&utm_marketing_tactic=marketplace_users&utm_source_platform=cgtrader',
      //   },
      //   {
      //     text: 'Custom 3D Modeling',
      //     link: 'https://www.modelry.ai/how-to-order-custom-3d-models?utm_source=cgtrader_marketplace&utm_medium=referral&utm_campaign=marketplace_shop&utm_id=00001&utm_term=2210&utm_content=3d_content_production&utm_creative_format=footer_menu&utm_marketing_tactic=marketplace_users&utm_source_platform=cgtrader',
      //   },
      //   {
      //     text: 'Virtual Photography',
      //     link: 'https://www.modelry.ai/virtual-photography?utm_source=cgtrader_marketplace&utm_medium=referral&utm_campaign=marketplace_shop&utm_id=00001&utm_term=2210&utm_content=virtual_photography&utm_creative_format=footer_menu&utm_marketing_tactic=marketplace_users&utm_source_platform=cgtrader',
      //   },
      // ],
      // aiImageGeneratorLinks: [
      //   {
      //     text: 'CGDream | AI Image Generator',
      //     link: 'https://cgdream.ai/',
      //   },
      //   {
      //     text: 'Generate Images with Flux Dev',
      //     link: 'https://cgdream.ai/features/free-flux-ai-image-generator',
      //   },
      //   {
      //     text: 'Text to Image AI',
      //     link: 'https://cgdream.ai/features/text-to-image-ai-generator',
      //   },
      //   {
      //     text: 'AI Photo Editor',
      //     link: 'https://cgdream.ai/features/ai-photo-editor',
      //   },
      //   {
      //     text: 'AI 3D Rendering',
      //     link: 'https://cgdream.ai/features/ai-3d-rendering',
      //   },
      //   {
      //     text: 'AI 3D Model Generator',
      //     link: 'https://cgdream.ai/features/ai-3d-model-generator-image-to-3d',
      //   },
      //   {
      //     text: 'AI Filters for Images',
      //     link: 'https://cgdream.ai/features/ai-filters-for-images',
      //   },
      //   {
      //     text: 'AI Image Upscaler',
      //     link: 'https://cgdream.ai/features/ai-image-upscaler',
      //   },
      //   {
      //     text: 'AI Image Inpainting',
      //     link: 'https://cgdream.ai/features/ai-image-inpainting',
      //   },
      // ],
    },
    'bottom-row': {
      'terms-link': 'Terms & Conditions',
      'privacy': 'Privacy',
    },
  },
  items: {
    last_card: {
      text: "Couldn't find what you're looking for?",
      button_text: 'Request a custom 3D model',
    },
  },
  enterprise: {
    'title': 'Business Account',
    'subtitle':
      '3D content source for any type of business - from small design studios to large enterprises',
    'review':
      'CGTrader is a great partner for our needs. We found the Prepaid credit payments very convenient for making purchases on the platform and custom reporting solutions help us a lot with asset management.',
    'reviewAuthor': 'Shouyi Lu, Yahaha Studios',
    'formTitle': 'Apply for a business account by filling your details below',
    "company'": {
      label: 'Company name',
    },
    'full_name': {
      label: 'Your name',
    },
    'email': {
      label: 'Email',
    },
    'apply': 'Apply',
    'applySuccess': 'Successfully applied',
    '3dContent': {
      title: 'Quality 3D content at any scale',
      list: {
        assets:
          'More than 1.6 million readily available 3D assets to choose from',
        custom: 'Custom 3D modeling at scale',
        manager: 'Dedicated customer success managers',
        search:
          'Tailored search support and 3D technical support (from advice to a model conversion)',
      },
    },
    'licensing': {
      title: 'Business oriented licensing',
      list: {
        licenses: 'Only two default licenses with clear terms',
        royaltyFree:
          'Royalty-free license allows a wide range of commercial use',
        modelsSold:
          '90% of the models are sold on the marketplace with a Royalty-free license',
        guidance: 'Guidance and advice on licensing and use',
      },
    },
    'payment': {
      title: 'Easy payment and sharing',
      list: {
        offers: 'Special offers and discounts',
        flexiblePayment: 'Flexible payment terms and more convenient checkout',
        digitalAsset:
          'Digital Asset Management system (cloud-based 3D model storage)',
        shareAccounts:
          'Ability to share accounts and simplify payments for your employees',
      },
    },
    'errors': {
      email: 'Invalid email',
      required: 'This field is required',
    },
  },
  coupons: {
    title: 'Coupons',
    faq: 'Faq',
    deal: 'DEAL',
    couponExpires: 'Coupon Expires',
    getDeal: 'Get deal',
    useCode: 'Use code:',
    bannerTitle: 'CGTrader Coupons and Promo Codes %{year}',
    bannerSubtitle:
      "Seeking official CGTrader coupon codes? Look no further – you're in the right spot for the best discounts",
    couponsList: {
      discount:
        'Sign up and receive a 10% discount for your first purchase',
      freeModels: 'Download high-quality 3D models for free',
      discounts:
        'Sign up and get notified about time-limited discounts for your purchases',
    },
  },
  model: {
    download_limit_exceeded: 'You have exceeded your daily download limit. Please try again tomorrow. This limit does not apply to users who have made a purchase in the last 12 months.',
    download_limit_exceeded_tiered: 'You have exceeded your daily free download limit of {{limit}} downloads. Subscribe to CGTrader to unlock more daily downloads.',
    subscription: {
      limit_reached_detailed: "You've reached your {{limit}} download limit for this month. Your limit resets on {{reset_date}}. To download more models now, you can purchase them individually.",
      limit_reached_detailed_no_date: "You've reached your {{limit}} download limit for this month. To download more models now, you can purchase them individually.",
    },
  },
  share_modal: {
    title: 'Share model',
    aria_label: 'Share Modal',
    share_on: 'Share on {{network}}',
  },
  search_page: {
    seo_area: {
      by_relevance: 'By relevance:',
      by_extension: 'By extension:',
      by_style: 'By style:',
      by_type: 'By type:',
    },
    results: {
      // TODO(design): confirm final copy for the results error state.
      empty_title: 'No models found',
      empty_description: 'Try changing or removing some filters.',
      clear_filters: 'Clear filters',
      search_all_types: 'Search all types',
      error: 'Something went wrong loading results. Please try again.',
      pagination: 'Search results pages',
      showing: 'Showing {{start}}-{{end}} of {{total}}',
      per_page: 'Per page',
      first_page: 'Go to first page',
      previous_page: 'Go to previous page',
      next_page: 'Go to next page',
      last_page: 'Go to last page',
      page_input: 'Jump to page',
      results_count: '{{total}} results',
      models_count: '{{total}} model',
      models_count_plural: '{{total}} models',
    },
    promo_cards: {
      section_title: 'Can\'t find what you\'re looking for?',
      ai: {
        title: 'Generate 3D Models with {{brand}}',
        description: 'Create high-quality 3D models from images or text prompts using AI — fast, intuitive, and ready for production.',
        cta: 'Generate 3D Model',
        free_trial: 'Free trial available',
      },
      freelancer: {
        title: 'Hire a 3D freelancer with CGTrader',
        description: 'Hire freelance 3D designers for custom 3D modeling, printing, and animation. Post a project and compare quotes.',
        cta: 'Post a Project',
      },
    },
    filters: {
      clear_search: 'Clear search',
      poly_count: {
        title: 'Poly count',
        low_poly_label: 'Low-poly',
        low_poly_value: 'up to 20k',
        mid_poly_label: 'Mid-poly',
        mid_poly_value: '20k - 100k',
        high_poly_label: 'High-poly',
        high_poly_value: '100k - 1M+',
        reset: 'Reset',
        checkboxes_group_label: 'Polygon range options',
        // TODO(design): confirm final copy. Current placeholder describes the three poly-count tiers.
        info_tooltip: 'Polygon count is the total number of polygons that compose a 3D model.\n\nLow-poly: up to 20k — ideal for real-time use (games, mobile, AR/VR).\nMid-poly: 20k – 100k — balanced for most production needs.\nHigh-poly: 100k – 1M+ — best for renders, films, and product visualization.',
      },
      style: {
        title: 'Style',
        find_placeholder: 'Find styles...',
        no_matches: 'No matches',
        reset: 'Reset',
        tags_group_label: 'Style options',
        show_more: 'Show more',
        show_less: 'Show less',
        groups: {
          look: 'Look',
          aesthetic: 'Aesthetic',
          theme: 'Theme',
        },
        styles: {
          realistic: 'Realistic',
          stylized_low_poly: 'Stylized & Low-poly',
          stylized: 'Stylized',
          cartoon_anime: 'Cartoon & Anime',
          modern: 'Modern',
          modern_industrial: 'Modern & Industrial',
          minimalist_abstract: 'Minimalist & Abstract',
          classic_vintage: 'Classic & Vintage',
          industrial: 'Industrial',
          elegant_ornate: 'Elegant & Ornate',
          fantasy_sci_fi: 'Fantasy & Sci-Fi',
          historical_military: 'Historical & Military',
        },
      },
      features: {
        title: 'Features',
        title_with_count: 'Features ({{count}})',
        search_placeholder: 'Find features...',
        no_matches: 'No matches',
        reset: 'Reset',
        show_more: 'Show more',
        show_less: 'Show less',
        game_ready: 'Game-ready',
        with_renders: 'Has renders',
        scene: 'Scene',
      },
      size: {
        title: 'Size',
        unit: 'Unit',
        units: {
          cm: 'Centimeters (cm)',
          in: 'Inches (in)',
          mm: 'Millimeters (mm)',
        },
        whole_print_size: 'Whole print size',
        largest_print_size: 'Largest print size',
        width: 'Width (X)',
        depth: 'Depth (Y)',
        height: 'Height (Z)',
        quick_select: 'Quick select',
        presets: {
          under_5: '< 5 cm',
          range_5_15: '5 - 15 cm',
          range_15_30: '15 - 30 cm',
          range_30_50: '30 - 50 cm',
          range_50_100: '50 - 100 cm',
          over_100: '100 cm +',
        },
        reset: 'Reset',
      },
      categories: {
        title: 'Categories',
      },
      date_published: {
        title: 'Date published',
        all_time: 'All Time',
        last_24_hours: 'Last 24 hours',
        last_7_days: 'Last 7 days',
        last_30_days: 'Last 30 days',
        last_6_months: 'Last 6 months',
        last_12_months: 'Last 12 months',
        custom: 'Choose date manually',
        short: {
          last_24_hours: '24 hours',
          last_7_days: '7 days',
          last_30_days: '30 days',
          last_6_months: '6 months',
          last_12_months: '12 months',
          custom: 'Custom date',
        },
        start_date: 'Start date',
        end_date: 'End date',
        previous_month: 'Previous month',
        next_month: 'Next month',
        cancel: 'Cancel',
        apply: 'Apply',
      },
      designers: {
        title: 'Designer',
        search_placeholder: 'Find designer...',
        following: 'Following',
        following_indicator: 'Following',
        following_tooltip: "You're following this designer",
        top: 'Top Designers',
        models_count: '{{count}} model',
        models_count_plural: '{{count}} models',
        loading: 'Loading designers...',
        searching: 'Searching designers...',
        no_results: 'No designers found.',
        no_following: 'You are not following any designers yet',
        show_more: 'Show more',
      },
      advanced: {
        title: 'Advanced filters',
        general_group_label: 'OTHER',
        status_group_label: 'STATUS',
        packs: 'Packs',
        has_marmoset: '3D Viewer',
        has_video: 'Video available',
        cgt_standard: 'CGT Standard',
        cgt_standard_tooltip: 'Show only models whose FBX files passed CGTrader\'s automated checks for geometry, UVs, textures, materials, and file structure.',
        wishlist: 'Wishlist',
        liked: 'Liked',
        purchased: 'Purchased',
        hide_purchased: 'Hide purchased',
        in_cart: 'In the cart',
      },
      file_format: {
        title: 'File format',
        search_placeholder: 'Type in to search...',
        popular: 'Popular',
        show_more: 'Show more',
        show_less: 'Show less',
        native_only: 'Only native',
        native_only_tooltip: 'Only original editable project file',
      },
      price: {
        title: 'Price',
        on_sale: 'On Sale',
        with_subscription: 'Subscription',
        your_plan: 'Your plan',
        subscription_promo: {
          title: 'Build more with Subscription',
          text: '{{limit}} monthly downloads and AI generations',
          cta: 'Learn More',
        },
        min_price: 'Min Price',
        max_price: 'Max Price',
        // Prices are USD marketplace-wide, so the range labels are identical in every locale;
        // they live here so localization can adjust format (spacing, symbol position) later.
        ranges: {
          free: 'Free',
          range_2_10: '$2 - $10',
          range_10_20: '$10 - $20',
          range_20_50: '$20 - $50',
          range_50_100: '$50 - $100',
          more_than_100: '$100+',
        },
        // Shorter forms for the row 1 trigger's active-state label (Figma 2989:109512).
        ranges_short: {
          free: 'Free',
          range_2_10: '$2-10',
          range_10_20: '$10-20',
          range_20_50: '$20-50',
          range_50_100: '$50-100',
          more_than_100: '$100+',
        },
        short: {
          on_sale: 'On Sale',
          min: 'Min {{price}}',
          max: 'Max {{price}}',
        },
      },
      license: {
        title: 'License',
        all: 'All Licenses',
        royalty_free: 'Royalty Free',
        editorial: 'Editorial Use',
        editorial_short: 'Editorial',
        custom: 'Custom',
      },
      quality: {
        title: 'Quality',
        levels: {
          any: 'Any',
          basic: 'Basic',
          premium: 'Premium',
          pro: 'Pro',
        },
        content_source: {
          all: 'All Content',
          all_short: 'All',
          ai_generated: 'AI Generated',
          human_created: 'Human Created',
        },
      },
      more_filters: {
        trigger_label: 'Filters',
        trigger_label_with_count: 'Filters ({{count}})',
        desktop_title: 'More filters',
        desktop_title_with_count: 'More filters ({{count}})',
        modal_title: 'All Filters',
        close_label: 'Close filters',
        reset: 'Reset',
        apply_with_count: 'Apply ({{total}})',
      },
      asset_type: {
        group_label: 'Asset type',
        all: 'All',
        three_d_only: '3D Only',
        three_d_only_short: '3D',
        three_d_print_only: '3D Print Only',
        three_d_print_only_short: '3D Print',
      },
      clear_all: 'Clear all filters',
      clear_all_short: 'Clear ({{count}})',
      sorting: {
        title: 'Sorting',
        trending: 'Trending',
        top_sellers: 'Top sellers',
        best_match: 'Best match',
        newest: 'Newest',
        oldest: 'Oldest',
        lower_price: 'Lower price',
        higher_price: 'Higher price',
      },
      secondary: {
        group_label: 'Secondary filters',
        search_placeholder: 'Search within results...',
      },
      search_within: {
        button_label: 'Search within results',
        button_label_with_count: 'Search within results ({{count}})',
        selected_group_label: 'Selected terms',
        remove_term: 'Remove {{term}}',
        related_searches: 'Related searches',
        search_with_count: 'Search ({{total}})',
      },
      technical_attributes: {
        group_label: 'Technical attributes',
        animated: 'Animated',
        rigged: 'Rigged',
        low_poly: 'Low-poly',
        pbr: 'PBR',
        scene: 'Scene',
      },
      print_attributes: {
        group_label: 'Print attributes',
        with_makes: 'Has makes',
        three_d_print_verified: '3D Print verified',
        pre_supported: 'Pre-Supported',
        multiple_parts: 'Multiple parts',
      },
      quick_filters: {
        group_label: 'Quick filters',
        in_my_plan: 'In my plan',
        in_my_wish_list: 'In my wishlist',
      },
      tags: {
        title: 'Tag suggestions',
        title_with_count: 'Tag suggestions ({{count}})',
        reset: 'Reset',
        tags_group_label: 'Tag suggestions',
        more: 'More',
        find_placeholder: 'Find categories...',
        no_matches: 'No matches',
        show_more: 'Show more',
        show_less: 'Show less',
      },
    },
  },
}
// jshint ignore: end
